import * as React from 'react'
import ListSubheader from '@mui/material/ListSubheader'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ChevronDown from 'mdi-material-ui/ChevronDown'
import ChevronRight from 'mdi-material-ui/ChevronRight'
import FastForward from 'mdi-material-ui/FastForward'
import PlusCircle from 'mdi-material-ui/PlusCircle'
import MinusCircleOutline from 'mdi-material-ui/MinusCircleOutline'
import ContentSave from 'mdi-material-ui/ContentSave'
import ShareVariant from 'mdi-material-ui/ShareVariant'
import Rewind from 'mdi-material-ui/Rewind'
import FolderOpenOutline from 'mdi-material-ui/FolderOpenOutline'
import ListItemText from '@mui/material/ListItemText'
import Collapse from '@mui/material/Collapse'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import { Theme, useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Chip from '@mui/material/Chip'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Button from '@mui/material/Button'
import Magnify from 'mdi-material-ui/Magnify'
import Refresh from 'mdi-material-ui/Refresh'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import IconButton from '@mui/material/IconButton'
import Divider from '@mui/material/Divider'
import Autocomplete from '@mui/material/Autocomplete'
import {
  darken,
  FilterOptionsState,
  lighten,
  Switch,
  Tooltip
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'
import {
  fetchAnalyzeInfoByAnalysisId,
  fetchSample,
  fetchSampleById,
  GenePanel,
  GeneSets,
  getGeneByHpoIds,
  getGeneByOmimPhenotypes,
  getGenePanel,
  getGeneSets,
  Sample,
  searchChinahpo,
  translate,
  TranslateDto
} from '@/@core/services/app.service'
import ChinahpoSearch, { Data, Film } from '../chinahpo-search'
import { useRouter } from 'next/router'
import { containsChinese, isJson, unique } from '@/@core/utils/utils'
import { CheckBoxOutlineBlank } from '@mui/icons-material'

export interface NObject {
  [key: string]: any
}

// const color = 'black'
// const bgColor = 'rgb(227, 226, 228)'

let color = 'black'
let bgColor = '#F7F9FA'

let geneName_List = [] as string[]
let rsId_List = [] as string[]
let RU_List = [] as string[]
let geneNameOut_List = [] as string[]
const OMIMIds = [] as string[]

const top100Films = [
  { title: 'The Shawshank Redemption', year: 1994 },
  { title: 'The Godfather', year: 1972 },
  { title: 'The Godfather: Part II', year: 1974 },
  { title: 'The Dark Knight', year: 2008 },
  { title: '12 Angry Men', year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: 'Pulp Fiction', year: 1994 }
]

const ACMG_classification = [
  'Pathogenic',
  'Likely pathogenic',
  'Uncertain significance',
  'Benign',
  'Likely benign',
  'VUS'
]

const classification = [
  'pathogenic',
  'likely pathogenic',
  'drug response',
  'uncertain significance',
  'benign',
  'likely benign'
]

const CLINVAR_variant = [
  'Pathogenic',
  'Likely pathogenic',
  'Uncertain significance',
  'Benign',
  'Likely benign'
]

const GLSGrading = [
  {
    key: 'pathogenic',
    title: 'Pathogenic',
    color: 'rgb(254,130,138)',
    hoverColor: 'rgb(254,130,138,0.8)'
  },
  {
    key: 'likely pathogenic',
    title: 'Likely Pathogenic',
    color: 'rgb(254,196,210)',
    hoverColor: 'rgb(254,196,210,0.8)'
  },
  {
    key: 'drug response',
    title: 'Drug Response',
    color: 'rgb(186,204,147)',
    hoverColor: 'rgb(186,204,147,0.8)'
  },
  {
    key: 'uncertain significance',
    title: 'Uncertain Significance',
    color: 'rgb(255,180,0)',
    hoverColor: 'rgb(255,180,0,0.8)'
  },
  {
    key: 'likely benign',
    title: 'Likely Benign',
    color: 'rgb(134,169,209)',
    hoverColor: 'rgb(134,169,209,0.8)'
  },
  {
    key: 'benign',
    title: 'Benign',
    color: 'rgb(103,142,197)',
    hoverColor: 'rgb(103,142,197,0.8)'
  },
  {
    key: 'loss of function',
    title: 'Loss Of Function',
    color: 'rgb(246,209,139)',
    hoverColor: 'rgb(246,209,139,0.8)'
  }
]

export const ACMGClassification = [
  {
    key: 'Pathogenic',
    title: 'Pathogenic',
    color: 'rgba(229,38,35,0.8)',
    hoverColor: 'rgb(229,38,35,0.6)'
  },
  {
    key: 'Likely pathogenic',
    title: 'Likely Pathogenic',
    color: 'rgb(221,109,32)',
    hoverColor: 'rgb(221,109,32,0.6)'
  },
  {
    key: 'Uncertain significance',
    title: 'Uncertain Significance',
    color: 'rgb(255,180,0)',
    hoverColor: 'rgb(255,180,0,0.6)'
  },
  {
    key: 'Likely benign',
    title: 'Likely Benign',
    color: 'rgb(107,148,200)',
    hoverColor: 'rgb(107,148,200,0.6)'
  },
  {
    key: 'Benign',
    title: 'Benign',
    color: 'rgb(103,142,197)',
    hoverColor: 'rgb(103,142,197,0.6)'
  },
  {
    key: '.',
    title: 'None',
    color: 'rgb(46, 125, 50,.6)',
    hoverColor: 'rgb(46, 125, 50,0.4)'
  }
]

export const ScipGeneHits = [
  {
    title: 'Sufficient',
    key: 'Sufficient'
  },
  {
    title: 'Emerging',
    key: 'Emerging'
  },
  {
    title: 'Little',
    key: 'Little'
  },
  {
    title: 'Recessive',
    key: 'Recessive'
  },
  {
    title: 'Unlikely',
    key: 'Unlikely'
  },
  {
    title: 'No evidence',
    key: 'No evidence'
  }
]

export const ScipClingenDose = [
  {
    title: '充足证据证明剂量敏感(3)',
    key: 'Sufficient (3)'
  },
  {
    title: '部分证据证明剂量敏感(2)',
    key: 'Emerging (2)'
  },
  {
    title: '几乎没有证据证明剂量敏感(1)',
    key: 'Little (1)'
  },
  {
    title:
      '常染色体隐性遗传病相关基因(可以没有假定的致病机制,如LOF或其他机制)(30)',
    key: 'Recessive (30)'
  },
  {
    title: '剂量不敏感(40)',
    key: 'Unlikely (40)'
  },
  {
    title: '剂量不敏感(0)',
    key: 'No evidence (0)'
  }
]

export const inheritance = [
  'autosomal recessive',
  'autosomal dominant',
  'somatic',
  'x-linked'
]

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: bgColor,
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: color
}))

const AutocompleteColor = styled(Autocomplete)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: `${color} !important`
  },
  '& .MuiInputBase-root': {
    borderRadius: 0,
    color: color
  },
  '& .MuiChip-root': {
    color: `${color} !important`
  },
  '& .MuiSvgIcon-root': {
    borderRadius: 0,
    color: `${color} !important`
  }
}))

const AutocompleteColors = styled(ChinahpoSearch)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: `${color} !important`
  },
  '& .MuiInputBase-root': {
    borderRadius: 0,
    color: color
  },
  '& .MuiChip-root': {
    color: `${color} !important`
  },
  '& .MuiSvgIcon-root': {
    borderRadius: 0,
    color: `${color} !important`
  }
}))

const SelectColor = styled(Select)(({ theme }) => ({
  borderRadius: 0,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: `${color} !important`
  },
  '& .MuiInputLabel-root': {
    color: `${color} !important`
  },
  '& .MuiInputBase-root': {
    borderRadius: `${0} !important`,
    color: `${color} !important`
  },
  '& #demo-simple-select': {
    color: `${color} !important`,
    minWidth: '2rem !important'
  },
  '& .MuiSvgIcon-root': {
    color: `${color} !important`
  },
  '& .MuiPopover-root': {
    zIndex: 10000
  },
  minWidth: 0
}))

const TextFieldColor = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: `${color} !important`
  },
  '& .MuiFormLabel-root': {
    color: `${color} !important`
  },
  '& .MuiInputBase-root': {
    borderRadius: 0,
    color: `${color} !important`
  },
  '& #demo-simple-select': {
    color: `${color} !important`
  }
}))

const ToggleButtonGroupColor = styled(ToggleButtonGroup)(({ theme }) => ({
  color: color,
  '& .Mui-selected': {
    borderColor: `${'rgb(46, 125, 50)'} !important`,
    backgroundColor: `${'rgb(46, 125, 50,0.6)'} !important`
  }
}))

const ToggleButtonColor = styled(ToggleButton)(({ theme }) => ({
  color: `${color} !important`,
  borderColor: `${color} !important`,
  borderRadius: `${0} !important`,
  ':hover': {
    backgroundColor: 'rgb(76,178,0)'
  },
  textTransform: 'none'
}))

export const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-8px',
  padding: '4px 10px',
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === 'light'
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8)
}))

export const GroupItems = styled('ul')({
  padding: 0
})

const UserLocusAutocomplete = (props: {
  label: string
  termList: any[]
  fn: any
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  const [search, setSearch] = React.useState<string>('')
  const [options, setOptions] = React.useState<readonly Film[]>([])
  const loading = open && options.length === 0
  const searchChinahpos = useMutation({
    mutationFn: async (data: string) =>
      await searchChinahpo({
        like: data
      }),
    onSuccess: (data: Data) => {
      //post返回的结果

      let list = [] as any[],
        list2 = [] as any[]

      if (data.phenotypeList && data.phenotypeList.data) {
        list = data.phenotypeList.data
          .filter((item) => item.hpo_code)
          .map((items) => {
            return {
              ...items,
              title: `${items.hpo_code}${items.name_en}(${items.name_cn})`
            }
          })
      }

      if (data.OMIMList && data.OMIMList.data) {
        list2 = data.OMIMList.data
          .filter((item) => item.omim_code)
          .map((items) => {
            return {
              ...items,
              title: `OMIM:${items.omim_code}"【${items.cn_title}(${items.pre_title})】`
            }
          })
      }

      //

      setOptions([...list, ...list2])
    }
  })

  React.useEffect(() => {
    let active = true

    searchChinahpos.mutate(search)

    return () => {
      active = false
    }
  }, [search])

  React.useEffect(() => {
    if (!open) {
      setOptions([])
    }
  }, [open])

  return (
    <AutocompleteColor
      id="asynchronous-demo"
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onClose={() => {
        setOpen(false)
      }}
      isOptionEqualToValue={(option: any, value: any) =>
        option.title === value.title
      }
      getOptionLabel={(option: any) => option.title}
      options={options}
      loading={loading}
      renderTags={
        ((value: readonly Film[], getTagProps: any) =>
          value.map((option: Film, index: number) => (
            <Chip
              variant="outlined"
              label={option.title}
              {...getTagProps({ index })}
              key={index}
              color={'secondary'}
              sx={{
                bgcolor: 'primary.main',
                color: 'white'
              }}
            />
          ))) as any
      }
      value={props.termList}
      multiple
      renderInput={(params) => (
        <TextFieldColor
          {...params}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            setSearch(e.target.value)
          }}
          label={props.label}
        />
      )}
      onChange={(e: any, v: any) => {
        // if (e.code === 'Backspace') return

        props.fn && props.fn([...v])
      }}
    />
  )
}

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 500
    }
  }
}
const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder'
]

export const VARIANT_ONTOLOGY = {
  Exonic: [
    {
      id: 'exonic',
      text: 'Exon'
    },
    {
      id: 'frameshift',
      text: 'Frameshift'
    },
    {
      id: 'inframe indel',
      text: 'Inframe indel'
    },
    {
      id: 'missense',
      text: 'Missense'
    },
    {
      id: 'start lost',
      text: 'Start loss'
    },
    {
      id: 'start retained',
      text: 'Start retained'
    },
    {
      id: 'stopgain',
      text: 'Stop gained'
    },
    {
      id: 'stoploss',
      text: 'Stop loss'
    },
    {
      id: 'stop retained',
      text: 'Stop retained'
    },
    {
      id: 'synonymous SNV',
      text: 'Synonymous'
    },
    {
      id: 'coding',
      text: 'Coding'
    },
    {
      id: 'nonframeshift',
      text: 'Nonframeshift'
    },
    {
      id: 'nonsynonymous SNV',
      text: 'Nonsynonymous'
    },
    {
      id: 'Protein altering variant',
      text: 'Protein altering variant'
    }
  ],
  Intronic: [
    {
      id: 'intronic',
      text: 'Intron'
    }
  ],
  Splicing: [
    {
      id: 'splicing',
      text: 'Splicing'
    },
    {
      id: 'splice_acceptor',
      text: 'Splice acceptor'
    },
    {
      id: 'splice_donor',
      text: 'Splice donor'
    },
    {
      id: 'splice_region',
      text: 'Splice region'
    },
    {
      id: 'splice_site_variant',
      text: 'Splice site variant'
    },
    {
      id: 'splice_region_variant',
      text: 'Splice region variant'
    },
    {
      id: 'splice_polypyrimidine_tract_variant',
      text: 'Splice polypyrimidine'
    }
  ],
  UTR: [
    {
      id: 'UTR',
      text: 'UTR'
    },
    {
      id: '3UTR',
      text: '3` UTR'
    },
    {
      id: '5UTR',
      text: '5` UTR'
    }
  ],
  Regulatory_region: [
    {
      id: 'regulatory_region',
      text: 'Regulatory Region'
    },
    {
      id: 'TF_site',
      text: 'TF site'
    },
    {
      id: 'sub_regulatory_region',
      text: 'Regulatory region'
    }
  ],
  Upstream: [
    {
      id: 'upstream',
      text: 'Upstream'
    },
    {
      id: 'NMD',
      text: 'NMD',
      dad: 'upstream'
    },
    {
      id: 'sub_upstream',
      text: 'Upstream variant'
    }
  ],
  Downstream: [
    {
      id: 'downstream',
      text: 'Downstream'
    }
  ],
  Other: [
    {
      id: 'other',
      text: 'Other'
    }
  ],
  Intergenic: [
    {
      id: 'intergenic',
      text: 'Intergenic'
    }
  ],
  NcRNA_exonic: [
    {
      id: 'ncRNA_exonic',
      text: 'ncRNA_exonic'
    }
  ],
  NcRNA_intronic: [
    {
      id: 'ncRNA_intronic',
      text: 'ncRNA_intronic'
    }
  ],
  NcRNA_splicing: [
    {
      id: 'ncRNA_splicing',
      text: 'ncRNA_splicing'
    }
  ],
  Noncoding: [
    {
      id: 'noncoding',
      text: 'Noncoding'
    },
    {
      id: 'noncoding_exon',
      text: 'Noncoding exon'
    },
    {
      id: 'noncoding_intron',
      text: 'Noncoding intron'
    }
  ]
}
export interface PickerChild {
  label: string // display string shown to the user
  token: string // internal key fed to buildOntologyFilters — never renamed
}
export interface PickerGroup {
  header: string // group row display name
  headerToken: string // token emitted when the header itself is checked
  children: PickerChild[]
  orphans?: string[] // labels reachable ONLY via the header (no child token)
}
export const TOKEN_TO_LABELS: Record<string, string[]> = {
  // VEP-native tokens
  frameshift: ['Frameshift'],
  'inframe indel': ['Inframe deletion', 'Inframe insertion'],
  missense: ['Missense'],
  'start lost': ['Start loss'],
  'start retained': ['Start retained'],
  stopgain: ['Stop gained'],
  stoploss: ['Stop lost'],
  'stop retained': ['Stop retained'],
  'synonymous SNV': ['Synonymous'],
  coding: ['Coding'],
  'Protein altering variant': ['Protein altering variant'],
  intron: ['Intron'],
  splice_acceptor: ['Splice acceptor'],
  splice_donor: ['Splice donor'],
  splice_region: ['Splice region'],
  splice_polypyrimidine: ['Splice polypyrimidine'],
  splice_donor_5th_base: ['Splice donor 5th base'], // new, VEP-115
  splice_donor_region: ['Splice donor region'], // new, VEP-115
  splice_site_variant: ['Splice acceptor', 'Splice donor'],
  splice_region_variant: [
    'Splice region',
    'Splice donor region',
    'Splice donor 5th base'
  ], // widened for VEP-115 parity
  '3UTR': ["3' UTR"],
  '5UTR': ["5' UTR"],
  TF_site: ['TF site'],
  sub_regulatory_region: ['Regulatory region'],
  NMD: ['NMD'],
  sub_upstream: ['Upstream'],
  sub_downstream: ['Downstream'],
  sub_intergenic: ['Intergenic'],
  noncoding_exon: ['Noncoding exon'],
  noncoding_intron: ['Noncoding transcript'],

  // Legacy ANNOVAR-vocabulary aliases (same biology, VEP rename).
  // Remove these rows once the frontend migrates to VEP-native tokens.
  nonframeshift: ['Inframe deletion', 'Inframe insertion'],
  'nonsynonymous SNV': ['Missense'],
  ncRNA_exonic: ['Noncoding exon'],
  ncRNA_intronic: ['Noncoding transcript']
}

export const TOKEN_TO_LOCATIONS: Record<string, string[]> = {
  exonic: ['exonic'],
  intronic: ['intronic'],
  splicing: ['splicing'],
  UTR: ['UTR3', 'UTR5'],
  '3UTR': ['UTR3'],
  '5UTR': ['UTR5'],
  regulatory_region: ['regulatory region'],
  upstream: ['upstream'],
  downstream: ['downstream'],
  intergenic: ['intergenic'],
  noncoding: ['noncoding intron', 'noncoding exon']
}

export const PICKER_GROUPS: PickerGroup[] = [
  {
    header: 'Exon',
    headerToken: 'exonic',
    children: [
      { label: 'Missense', token: 'missense' },
      { label: 'Frameshift', token: 'frameshift' },
      { label: 'Stop gained', token: 'stopgain' },
      { label: 'Stop lost', token: 'stoploss' },
      { label: 'Start loss', token: 'start lost' },
      { label: 'Inframe indel', token: 'inframe indel' },
      { label: 'Synonymous', token: 'synonymous SNV' },
      { label: 'Stop retained', token: 'stop retained' },
      { label: 'Start retained', token: 'start retained' },
      { label: 'Protein altering variant', token: 'Protein altering variant' },
      { label: 'Coding', token: 'coding' }
    ],
    orphans: ['Incomplete terminal codon', 'Initiator codon']
  },
  {
    header: 'Splicing',
    headerToken: 'splicing',
    children: [
      { label: 'Splice acceptor', token: 'splice_acceptor' },
      { label: 'Splice donor', token: 'splice_donor' },
      { label: 'Splice region', token: 'splice_region' },
      { label: 'Splice donor 5th base', token: 'splice_donor_5th_base' },
      { label: 'Splice donor region', token: 'splice_donor_region' },
      { label: 'Splice polypyrimidine', token: 'splice_polypyrimidine' },
      { label: 'Splice site', token: 'splice_site_variant' }, // pseudo: acceptor + donor
      { label: 'Splice region (all)', token: 'splice_region_variant' } // pseudo: region + donor region + donor 5th base
    ]
  },
  {
    header: 'Intron',
    headerToken: 'intronic',
    children: [{ label: 'Intron', token: 'intron' }]
  },
  {
    header: 'UTR',
    headerToken: 'UTR',
    children: [
      { label: "5' UTR", token: '5UTR' },
      { label: "3' UTR", token: '3UTR' }
    ]
  },
  {
    header: 'Regulatory region',
    headerToken: 'regulatory_region',
    children: [
      { label: 'Regulatory region', token: 'sub_regulatory_region' },
      { label: 'TF site', token: 'TF_site' }
    ]
  },
  {
    header: 'Upstream',
    headerToken: 'upstream',
    children: [
      { label: 'Upstream', token: 'sub_upstream' },
      { label: 'NMD', token: 'NMD' }
    ],
    orphans: ['Transcript ablation']
  },
  {
    header: 'Downstream',
    headerToken: 'downstream',
    children: [{ label: 'Downstream', token: 'sub_downstream' }]
  },
  {
    header: 'Non-coding',
    headerToken: 'noncoding',
    children: [
      { label: 'Noncoding exon', token: 'noncoding_exon' },
      { label: 'Noncoding transcript', token: 'noncoding_intron' }
    ]
  },
  {
    header: 'Intergenic',
    headerToken: 'intergenic',
    children: [{ label: 'Intergenic', token: 'sub_intergenic' }]
  },
  {
    header: 'Other / uncategorized',
    headerToken: 'other', // compound token, NOT a location — handled by COMPOUND_TOKENS
    children: []
  }
]

export const TOKEN_All: Record<string, string[]> = {
  ...TOKEN_TO_LABELS,
  ...TOKEN_TO_LOCATIONS
}

export type Clause = Record<string, unknown>
export const COMPOUND_TOKENS: Record<string, Clause[]> = {
  other: [
    { field: 'consequence_labels', op: 'contains', value: 'other' },
    { field: 'consequence_labels', op: 'is_empty' }
  ]
}

const machineSelect = ['symptom', 'illness', 'unknown']

export const sequenceOntology = Object.getOwnPropertyNames(VARIANT_ONTOLOGY)
  .map((key) => {
    return {
      firstLetter: key,
      value: VARIANT_ONTOLOGY[key as 'Exonic']
    }
  })
  .map((items) => {
    return items.value.map((item) => {
      return {
        firstLetter: items.firstLetter,
        value: item
      }
    })
  })
  .flat()

export const tokenAll = PICKER_GROUPS.map((items, index) => {
  return {
    firstLetter: items.header,
    value: PICKER_GROUPS[index].children.map((item) => {
      return {
        id: item.label,
        text: item.token
      }
    })
  }
})
  .map((items) => {
    return items.value.map((item) => {
      return {
        firstLetter: items.firstLetter,
        value: item
      }
    })
  })
  .flat()

const FilterVariants = React.forwardRef(
  (
    props: {
      filterType: {
        title?: any
        key?: string | undefined
        checked?: boolean | undefined
      }
      fn: any
      analysisInfo?: any
      color?: 'white' | 'black' | any
      bgColor?: 'black' | 'rgb(227, 226, 228)' | 'rgb(0, 0, 0,0.6)'
    },
    ref
  ) => {
    bgColor = props.bgColor ? props.bgColor : bgColor

    color = props.color ? props.color : color

    const router = useRouter()

    const { id } = router.query

    const pageType = router.asPath.includes('/samples') ? 'sample' : 'analyze'

    const { t, i18n } = useTranslation()
    const [omimValue, setOmimValue] = React.useState('')

    const snvCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('genetic-way'),
        key: 'inheritance',
        open: false,
        value: {
          inheritance: [] as string[]
        } as NObject
      },
      {
        name: t('Zygosity'),
        key: 'zygosity',
        open: false,
        value: {
          zygosity: ''
        } as NObject
      },
      {
        name: 'ROH',
        key: 'ROH',
        open: false,
        value: {
          is_ROH: []
        } as NObject
      },
      {
        name: t('phenotype'),
        key: 'phenotypes',
        open: false,
        value: {
          isUse: null,
          phenotypes: [] as string[],
          clinicalSynopsisAnd: [] as string[]
        } as NObject
      },
      {
        name: t('OMIM'),
        key: 'OMIM',
        open: false,
        value: {
          mimNumbers: []
        } as NObject
      },
      {
        name: t('area'), // 无
        open: false,
        value: {
          geneSet: [] as string[]
        } as NObject
      },
      {
        name: t('Reads depth'),
        key: 'readDepth',
        open: false,
        value: {
          readDepthOperator: 'gte',
          readDepthValue: ''
        } as NObject
      },
      {
        name: t('Index'),
        key: 'index',
        open: false,
        value: {
          ownerIndexMin: 0,
          ownerIndexMax: 0,
          indexMin: 0,
          indexMax: 0,
          organizationIndexMin: 0,
          organizationIndexMax: 0
        } as NObject
      },
      {
        name: t('Allele fraction'),
        key: 'indelOperator',
        open: false,
        value: {
          indelOperator: 'gte',
          indelValue: '',
          snvOperator: 'gte',
          snvValue: ''
        } as NObject
      },
      {
        name: t('Variation mass value'),
        key: 'qualMin',
        open: false,
        value: {
          qualMin: 0,
          qualMax: 0
        } as NObject
      },
      {
        name: t('Population frequency'),
        key: 'gnomAD',
        open: false,
        value: {
          gnomAD: [],
          gnomADOperator: 'lte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          gnomADValue: ''
        } as NObject
      },

      {
        name: `GLS ${t('pathogenic classification')}`,
        key: 'classification',
        open: false,
        value: {
          CLINSIG_final: null
        } as NObject
      },
      {
        name: t('CLINVAR_clnsig'),
        key: 'CLINVAR_clnsig_final',
        open: false,
        value: {
          CLINVAR_clnsig_final: null
        } as NObject
      },
      {
        name: t('In-Silico predictions'),
        key: 'insilico',
        open: false,
        value: {
          insilico: [],
          CADDValue: null,
          fscoreValue: null,
          fscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          gscoreValue: null,
          gscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          alphaMValue: null,
          alphaMOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          spliceAIValue: null,
          spliceAIOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          revelValue: null,
          revelOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
        } as NObject
      },
      {
        name: `ACMG ${t('rating')}`,
        key: 'variantScore',
        open: false,
        value: {
          acmgClassification: [],
          acmgScoreValue: null,
          acmgScoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
        } as NObject
      },
      {
        name: t('Variant option'),
        key: 'variantOption',
        open: false,
        value: {
          sequenceOntology: [],
          userLocusIn: [],
          userLocusOut: []
        } as NObject
      },
      {
        name: t('Variant Sources'),
        key: 'sampleSource',
        open: false,
        value: {
          sampleSource: []
        } as NObject
      },
      {
        name: `Clinvar ${t('Publication')}`,
        key: 'pubmed',
        open: false,
        value: {
          hasPubmed: []
        } as NObject
      }
    ]

    const cnvCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('phenotype'),
        key: 'phenotypes',
        open: false,
        value: {
          isUse: null,
          phenotypes: [] as string[],
          clinicalSynopsisAnd: [] as string[]
        } as NObject
      },
      {
        name: t('Length'),
        key: 'Length',
        open: false,
        value: {
          lengthOperator: 'gte',
          lengthValue: ''
        } as NObject
      },
      {
        name: `${t('rating')}`,
        key: 'classification',
        open: false,
        value: {
          classification: []
        } as NObject
      },
      {
        name: `CNV ${t('Type')}`,
        key: 'SVType',
        open: false,
        value: {
          SVType: []
        } as NObject
      },
      {
        name: `CNV ${t('Highlights')}`,
        key: 'scip_Highlights',
        open: false,
        value: {
          hasPositiveHighlight: false,
          hasNegativeHighlight: false
        } as NObject
      },
      {
        name: t('gnomAD SV & Clinvar SV'),
        key: 'scip_gnomAD&Clinvar',
        open: false,
        value: {
          scipOverlapRateValue: null,
          scipOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGnomAdOverlapRateValue: null,
          scipGnomAdOverlapRateOperator: 'gte' as
            | 'lte'
            | 'gte'
            | 'lte.'
            | 'gte.',
          scipClinvarOverlapRateValue: null,
          scipClinvarOverlapRateOperator: 'gte' as
            | 'lte'
            | 'gte'
            | 'lte.'
            | 'gte.'
        } as NObject
      },
      {
        name: t('Gene info'),
        key: 'scip_Geneinfo',
        open: false,
        value: {
          scipGeneOverlapRateValue: null,
          scipGeneOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGenePliValue: null,
          scipGenePliOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGeneLoeufValue: null,
          scipGeneLoeufOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGeneHiIn: [],
          scipGeneTsIn: []
        } as NObject
      },
      {
        name: t('Clingen'),
        key: 'scip_Clingen',
        open: false,
        value: {
          scipClingenHaploIn: [],
          scipClingenTriploIn: []
        } as NObject
      }
    ]

    const svCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('phenotype'),
        key: 'phenotypes',
        open: false,
        value: {
          isUse: null,
          phenotypes: [] as string[],
          clinicalSynopsisAnd: [] as string[]
        } as NObject
      },
      {
        name: t('Length'),
        key: 'Length',
        open: false,
        value: {
          lengthOperator: 'gte',
          lengthValue: ''
        } as NObject
      },
      {
        name: `${t('rating')}`,
        key: 'classification',
        open: false,
        value: {
          classification: []
        } as NObject
      },
      {
        name: `CNV ${t('Type')}`,
        key: 'SVType',
        open: false,
        value: {
          SVType: []
        } as NObject
      }
    ]

    const glsSnvCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('genetic-way'),
        key: 'inheritance',
        open: false,
        value: {
          inheritance: [] as string[]
        } as NObject
      },
      {
        name: t('Zygosity'),
        key: 'zygosity',
        open: false,
        value: {
          zygosity: ''
        } as NObject
      },
      {
        name: t('RSId'),
        key: 'rsId',
        open: false,
        value: {
          rsId: []
        } as NObject
      },
      {
        name: 'ROH',
        key: 'ROH',
        open: false,
        value: {
          is_ROH: []
        } as NObject
      },

      // {
      //   name: 'Loss of Function',
      //   key: 'loss_of_function',
      //   open: false,
      //   value: {
      //     is_loss_of_function: []
      //   } as NObject
      // },

      {
        name: t('OMIM'),
        key: 'OMIM',
        open: false,
        value: {
          mimNumbers: []
        } as NObject
      },
      {
        name: t('Phenotype'),
        key: 'glsphenotypes',
        open: false,
        value: {
          glsphenotypes: [] as string[]
        } as NObject
      },
      {
        name: t('Reads depth'),
        key: 'readDepth',
        open: false,
        value: {
          readDepthOperator: 'gte',
          readDepthValue: ''
        } as NObject
      },
      {
        name: t('Allele fraction'),
        key: 'indelOperator',
        open: false,
        value: {
          indelOperator: 'gte',
          indelValue: '',
          snvOperator: 'gte',
          snvValue: ''
        } as NObject
      },
      {
        name: t('Index'),
        key: 'index',
        open: false,
        value: {
          ownerIndexMin: 0,
          ownerIndexMax: 0,
          indexMin: 0,
          indexMax: 0,
          organizationIndexMin: 0,
          organizationIndexMax: 0
        } as NObject
      },
      {
        name: t('Variation mass value'),
        key: 'qualMin',
        open: false,
        value: {
          qualMin: 0,
          qualMax: 0
        } as NObject
      },
      {
        name: t('Population frequency'),
        key: 'gnomAD',
        open: false,
        value: {
          gnomAD: [],
          gnomADOperator: 'lte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          gnomADValue: ''
        } as NObject
      },
      {
        name: t('CLINVAR_clnsig'),
        key: 'CLINVAR_clnsig_final',
        open: false,
        value: {
          CLINVAR_clnsig_final: null
        } as NObject
      },
      {
        name: t('In-Silico predictions'),
        key: 'insilico',
        open: false,
        value: {
          insilico: [],
          CADDValue: null,
          fscoreValue: null,
          fscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          gscoreValue: null,
          gscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          alphaMValue: null,
          alphaMOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          spliceAIValue: null,
          spliceAIOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          revelValue: null,
          revelOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
        } as NObject
      },
      {
        name: `ACMG ${t('rating')}`,
        key: 'variantScore',
        open: false,
        value: {
          acmgClassification: [],
          acmgScoreValue: null,
          acmgScoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
        } as NObject
      },

      {
        name: `GLS ${t('pathogenic classification')}`,
        key: 'classification',
        open: false,
        value: {
          CLINSIG_final: null
        } as NObject
      },
      {
        name: `Clinvar ${t('Publication')}`,
        key: 'pubmed',
        open: false,
        value: {
          hasPubmed: []
        } as NObject
      },

      // {
      //   name: `${t('Consequence labels')}`,
      //   key: 'tokenToLabels',
      //   open: false,
      //   value: {
      //     tokenToLabels: []
      //   } as NObject
      // },
      {
        name: t('Variant Sources'),
        key: 'sampleSource',
        open: false,
        value: {
          sampleSource: []
        } as NObject
      },
      {
        name: `${t('Variant locations')}`,
        key: 'tokenToLocations',
        open: false,
        value: {
          tokenToLocations: []
        } as NObject
      }
    ]

    const glsCnvCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('Phenotype'),
        key: 'glsphenotypesCNV',
        open: false,
        value: {
          glsphenotypesCNV: [] as string[]
        } as NObject
      },

      {
        name: t('OMIM'),
        key: 'OMIM',
        open: false,
        value: {
          mimNumbers: []
        } as NObject
      },
      {
        name: t('Length'),
        key: 'Length',
        open: false,
        value: {
          lengthOperator: 'gte',
          lengthValue: ''
        } as NObject
      },
      {
        name: `${t('rating')}`,
        key: 'classification',
        open: false,
        value: {
          ccnv_classification: []
        } as NObject
      },
      {
        name: `CNV ${t('Type')}`,
        key: 'SVType',
        open: false,
        value: {
          SVType: []
        } as NObject
      },
      {
        name: `CNV ${t('Highlights')}`,
        key: 'scip_Highlights',
        open: false,
        value: {
          hasPositiveHighlight: false,
          hasNegativeHighlight: false
        } as NObject
      },
      {
        name: t('gnomAD SV & Clinvar SV'),
        key: 'scip_gnomAD&Clinvar',
        open: false,
        value: {
          scipOverlapRateValue: null,
          scipOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGnomAdOverlapRateValue: null,
          scipGnomAdOverlapRateOperator: 'gte' as
            | 'lte'
            | 'gte'
            | 'lte.'
            | 'gte.',
          scipClinvarOverlapRateValue: null,
          scipClinvarOverlapRateOperator: 'gte' as
            | 'lte'
            | 'gte'
            | 'lte.'
            | 'gte.'
        } as NObject
      },
      {
        name: t('Gene info'),
        key: 'scip_Geneinfo',
        open: false,
        value: {
          scipGeneOverlapRateValue: null,
          scipGeneOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGenePliValue: null,
          scipGenePliOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGeneLoeufValue: null,
          scipGeneLoeufOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          scipGeneHiIn: [],
          scipGeneTsIn: []
        } as NObject
      }
    ]

    const glsSvCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('Phenotype'),
        key: 'glsphenotypesCNV',
        open: false,
        value: {
          glsphenotypesCNV: [] as string[]
        } as NObject
      },
      {
        name: t('Length'),
        key: 'Length',
        open: false,
        value: {
          lengthOperator: 'gte',
          lengthValue: ''
        } as NObject
      },
      {
        name: `${t('rating')}`,
        key: 'sv_classification',
        open: false,
        value: {
          sv_classification: []
        } as NObject
      },
      {
        name: `CNV ${t('Type')}`,
        key: 'SVType',
        open: false,
        value: {
          SVType: []
        } as NObject
      }
    ]

    const strCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('phenotype'),
        key: 'phenotypes',
        open: false,
        value: {
          phenotypes: [] as string[]
        } as NObject
      },
      {
        name: t('RU'),
        key: 'RU',
        open: false,
        value: {
          RU: [] as string[]
        } as NObject
      },
      {
        name: t('GangStr_dp'),
        key: 'GangStr_dp',
        open: false,
        value: {
          gangStrDpOperator: 'gte',
          gangStrDpValue: ''
        } as NObject
      },
      {
        name: t('GangStr_q'),
        key: 'GangStr_q',
        open: false,
        value: {
          gangStrQualityOperator: 'gte',
          gangStrQualityValue: ''
        } as NObject
      },
      {
        name: t('EH_ref'),
        key: 'EH_ref',
        open: false,
        value: {
          expansionHunterRefOperator: 'gte',
          expansionHunterRefValue: ''
        } as NObject
      }
    ]

    const totalCon = [
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('phenotype'),
        key: 'phenotypes',
        open: false,
        value: {
          isUse: null,
          phenotypes: [] as string[],
          clinicalSynopsisAnd: [] as string[]
        } as NObject
      },
      {
        name: t('OR'),
        key: 'OR',
        open: false,
        value: {
          oddsRatioOperator: 'gte',
          oddsRatioValue: ''
        } as NObject
      },
      {
        name: t('P-value'),
        key: 'P-value',
        open: false,
        value: {
          pValueOperator: 'gte',
          pValueValue: ''
        } as NObject
      },
      {
        name: t('total Cases'),
        key: 'totalCases',
        open: false,
        value: {
          totalCasesOperator: 'gte',
          totalCasesValue: ''
        } as NObject
      },
      {
        name: t('total Controls'),
        key: 'totalControls',
        open: false,
        value: {
          totalControlsOperator: 'gte',
          totalControlsValue: ''
        } as NObject
      }
    ]

    const cohortCon = [
      {
        name: t('chromosome'),
        key: 'chrom',
        open: false,
        value: {
          chrom: [],
          posStart: '',
          posEnd: ''
        } as NObject
      },
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('genetic-way'),
        key: 'inheritance',
        open: false,
        value: {
          inheritance: [] as string[]
        } as NObject
      },
      {
        name: t('Zygosity'),
        key: 'zygosity',
        open: false,
        value: {
          zygosity: ''
        } as NObject
      },
      {
        name: 'ROH',
        key: 'ROH',
        open: false,
        value: {
          is_ROH: []
        } as NObject
      },
      {
        name: t('phenotype'),
        key: 'phenotypes',
        open: false,
        value: {
          isUse: null,
          phenotypes: [] as string[],
          clinicalSynopsisAnd: [] as string[]
        } as NObject
      },
      {
        name: t('Reads depth'),
        key: 'readDepth',
        open: false,
        value: {
          readDepthOperator: 'gte',
          readDepthValue: ''
        } as NObject
      },
      {
        name: t('Index'),
        key: 'index',
        open: false,
        value: {
          ownerIndexMin: 0,
          ownerIndexMax: 0,
          indexMin: 0,
          indexMax: 0,
          organizationIndexMin: 0,
          organizationIndexMax: 0
        } as NObject
      },
      {
        name: t('Allele fraction'),
        key: 'indelOperator',
        open: false,
        value: {
          indelOperator: 'gte',
          indelValue: '',
          snvOperator: 'gte',
          snvValue: ''
        } as NObject
      },
      {
        name: t('Variation mass value'),
        key: 'qualMin',
        open: false,
        value: {
          qualMin: 0,
          qualMax: 0
        } as NObject
      },
      {
        name: t('Population frequency'),
        key: 'gnomAD',
        open: false,
        value: {
          gnomAD: [],
          gnomADOperator: 'lte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          gnomADValue: ''
        } as NObject
      },

      {
        name: `GLS ${t('pathogenic classification')}`,
        key: 'classification',
        open: false,
        value: {
          CLINSIG_final: null
        } as NObject
      },
      {
        name: t('CLINVAR_clnsig'),
        key: 'CLINVAR_clnsig_final',
        open: false,
        value: {
          CLINVAR_clnsig_final: null
        } as NObject
      },
      {
        name: t('In-Silico predictions'),
        key: 'insilico',
        open: false,
        value: {
          insilico: [],
          CADDValue: null,
          fscoreValue: null,
          fscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          gscoreValue: null,
          gscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          alphaMValue: null,
          alphaMOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          spliceAIValue: null,
          spliceAIOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
          revelValue: null,
          revelOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
        } as NObject
      },
      {
        name: `ACMG ${t('rating')}`,
        key: 'variantScore',
        open: false,
        value: {
          acmgClassification: [],
          acmgScoreValue: null,
          acmgScoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
        } as NObject
      },
      {
        name: t('Variant option'),
        key: 'variantOption',
        open: false,
        value: {
          sequenceOntology: [],
          userLocusIn: [],
          userLocusOut: []
        } as NObject
      },
      {
        name: t('OR'),
        key: 'OR',
        open: false,
        value: {
          oddsRatioOperator: 'gte',
          oddsRatioValue: ''
        } as NObject
      },
      {
        name: t('P-value'),
        key: 'P-value',
        open: false,
        value: {
          pValueOperator: 'gte',
          pValueValue: ''
        } as NObject
      },
      {
        name: t('total Cases'),
        key: 'totalCases',
        open: false,
        value: {
          totalCasesOperator: 'gte',
          totalCasesValue: ''
        } as NObject
      },
      {
        name: t('total Controls'),
        key: 'totalControls',
        open: false,
        value: {
          totalControlsOperator: 'gte',
          totalControlsValue: ''
        } as NObject
      }
    ]

    const caseCon = [
      {
        name: t('gene'),
        key: 'gene',
        open: false,
        value: {
          genePanelSet: [],
          geneNameIn: [],
          geneNameOut: []
        } as NObject
      },
      {
        name: t('phenotype'),
        key: 'phenotypes',
        open: false,
        value: {
          isUse: null,
          phenotypes: [] as string[],
          clinicalSynopsisAnd: [] as string[]
        } as NObject
      },
      {
        name: t('OR'),
        key: 'OR',
        open: false,
        value: {
          oddsRatioOperator: 'gte',
          oddsRatioValue: ''
        } as NObject
      },
      {
        name: t('P-value'),
        key: 'P-value',
        open: false,
        value: {
          pValueOperator: 'gte',
          pValueValue: ''
        } as NObject
      },
      {
        name: t('Log_Pvalue'),
        key: 'logPvalue',
        open: false,
        value: {
          logPvalueOperator: 'gte',
          logPvalueValue: ''
        } as NObject
      },
      {
        name: t('Count'),
        key: 'Count',
        open: false,
        value: {
          countOperator: 'gte',
          countValue: ''
        } as NObject
      },
      {
        name: t('Hits_ratio'),
        key: 'Hits_ratio',
        open: false,
        value: {
          hitsRatioOperator: 'gte',
          hitsRatioValue: ''
        } as NObject
      }
    ]

    let filterConfig = snvCon

    if (
      props.filterType &&
      props.filterType.title &&
      props.filterType.title.includes('CNV')
    ) {
      filterConfig = cnvCon

      if (!props.analysisInfo?.hasSCIP) {
        filterConfig = filterConfig.filter(
          (item) => !item.key?.includes('scip_')
        )
      }
    }

    if (
      props.filterType &&
      props.filterType.title &&
      props.filterType.title.includes('SV')
    ) {
      filterConfig = svCon
    }

    if (props.analysisInfo && props.analysisInfo.pipelineVersion) {
      filterConfig = glsSnvCon

      if (
        props.filterType &&
        props.filterType.title &&
        props.filterType.title.includes('CNV')
      ) {
        filterConfig = glsCnvCon

        if (!props.analysisInfo?.hasSCIP) {
          filterConfig = filterConfig.filter(
            (item) => !item.key?.includes('scip_')
          )
        }
      }

      if (
        props.filterType &&
        props.filterType.title &&
        props.filterType.title.includes('SV')
      ) {
        filterConfig = glsSvCon
      }
    }

    if (
      props.filterType &&
      props.filterType.title &&
      props.filterType.title.includes('STR')
    ) {
      filterConfig = strCon
    }

    if (
      props.filterType &&
      props.filterType.key &&
      props.filterType.key.includes('total')
    ) {
      filterConfig = totalCon
    }

    if (
      props.filterType &&
      props.filterType.key &&
      props.filterType.key.includes('cohort_sites')
    ) {
      filterConfig = cohortCon
    }

    if (
      props.filterType &&
      props.filterType.key &&
      props.filterType.key.includes('case_control')
    ) {
      filterConfig = caseCon
    }

    if (pageType === 'sample') {
      filterConfig = filterConfig.filter(
        (item) => item.name !== t('Variant Sources')
      )
    }

    if (
      props.filterType &&
      props.filterType.key &&
      props.filterType.key.includes('big_family')
    ) {
      filterConfig = filterConfig
        .filter((item) => item.name !== t('Variation mass value'))
        .filter((item) => item.name !== t('Allele fraction'))
    }

    const chromosome = [
      {
        title: t('chromosome') + '1',
        key: '1'

        // key: 1
      },
      {
        title: t('chromosome') + '2',
        key: '2'

        // key: 2
      },
      {
        title: t('chromosome') + '3',
        key: '3'

        // key: 3
      },
      {
        title: t('chromosome') + '4',
        key: '4'

        // key: 4
      },
      {
        title: t('chromosome') + '5',
        key: '5'

        // key: 5
      },
      {
        title: t('chromosome') + '6',
        key: '6'

        // key: 6
      },
      {
        title: t('chromosome') + '7',
        key: '7'

        // key: 7
      },
      {
        title: t('chromosome') + '8',
        key: '8'

        // key: 8
      },
      {
        title: t('chromosome') + '9',
        key: '9'

        // key: 9
      },
      {
        title: t('chromosome') + '10',
        key: '10'

        // key: 10
      },
      {
        title: t('chromosome') + '11',
        key: '11'

        // key: 11
      },
      {
        title: t('chromosome') + '12',
        key: '12'

        // key: 12
      },
      {
        title: t('chromosome') + '13',
        key: '13'

        // key: 13
      },
      {
        title: t('chromosome') + '14',
        key: '14'

        // key: 14
      },
      {
        title: t('chromosome') + '15',
        key: '15'

        // key: 15
      },
      {
        title: t('chromosome') + '16',
        key: '16'

        // key: 16
      },
      {
        title: t('chromosome') + '17',
        key: '17'

        // key: 17
      },
      {
        title: t('chromosome') + '18',
        key: '18'

        // key: 18
      },
      {
        title: t('chromosome') + '19',
        key: '19'

        // key: 19
      },
      {
        title: t('chromosome') + '20',
        key: '20'

        // key: 20
      },
      {
        title: t('chromosome') + '21',
        key: '21'

        // key: 21
      },
      {
        title: t('chromosome') + '22',
        key: '22'

        // key: 22
      },
      {
        title: t('chromosome') + 'X',
        key: 'X'

        // key: 23
      },
      {
        title: t('chromosome') + 'Y',
        key: 'Y'

        // key: 24
      },
      {
        title: t('chromosome') + 'MT',
        key: 'MT'

        // key: 25
      }
    ]

    const copyList = [
      {
        title: '0',
        key: -1
      },
      {
        title: '1',
        key: 1
      },
      {
        title: '2',
        key: 2
      },
      {
        title: '3',
        key: 3
      },
      {
        title: '>=4',
        key: 4
      }
    ]
    const [open, setOpen] = React.useState(false)
    const [machineOpen, setMachineOpen] = React.useState(false)
    const [type, setType] = React.useState('save')

    const handleClickOpen = (type: string) => {
      setType(type)

      setOpen(true)
    }

    const handleClose = () => {
      setOpen(false)

      setMachineOpen(false)

      setList([
        {
          input: '',
          select: 'symptom',
          key: 0
        }
      ])
    }

    const [config, setConfig] = React.useState(filterConfig)
    const [samples, setSample] = React.useState<Sample>()
    const theme = useTheme()
    const [personName, setPersonName] = React.useState<string[]>([])
    const [chinahpos, setChinahpos] = React.useState<readonly Film[]>([])
    const [saveVal, setSaveVal] = React.useState({
      filter: '0'
    })
    const [loadVal, setLoadVal] = React.useState({
      filter: '0'
    })
    const [shareVal, setShareVal] = React.useState({
      filter: '0',
      emails: []
    })

    React.useEffect(() => {
      //
    }, [config])

    const handleChange = (
      event: SelectChangeEvent<typeof personName>,
      items: any
    ) => {
      const {
        target: { value }
      } = event

      setPersonName(typeof value === 'string' ? value.split(',') : value)

      handleListChange(
        typeof value === 'string' ? value.split(',') : value,
        event.target.name,
        items
      )
    }
    const [area, setArea] = React.useState<string[]>([])

    const handleAreaChange = (
      event: SelectChangeEvent<typeof personName>,
      items: any
    ) => {
      let {
        target: { value }
      } = event

      value = String(value)

      setArea(typeof value === 'string' ? value.split(',') : value)

      handleListChange(
        typeof value === 'string' ? value.split(',') : value,
        event.target.name,
        items
      )
    }

    const handleListChange = (
      value: any,
      name: string,
      items: { name: string }
    ) => {
      const list = config.map((item) => {
        if (item.name === items.name) item.value[name] = value

        return item
      })

      setConfig(list)
    }

    const getTerms = (terms: any) => {
      if (terms) {
        if (Array.isArray(terms)) return terms
        else if (isJson(terms)) return JSON.parse(terms)
        else return []
      } else return []
    }

    const search = () => {
      props.fn && props.fn(config)
    }

    const reset = () => {
      props.fn && props.fn(null)
      let filterConfig = snvCon

      if (
        props.filterType &&
        props.filterType.title &&
        props.filterType.title.includes('CNV')
      ) {
        filterConfig = cnvCon

        if (!props.analysisInfo?.hasSCIP) {
          filterConfig = filterConfig.filter(
            (item) => !item.key?.includes('scip_')
          )
        }
      }

      if (
        props.filterType &&
        props.filterType.title &&
        props.filterType.title.includes('SV')
      ) {
        filterConfig = svCon
      }

      if (
        props.filterType &&
        props.filterType.title &&
        props.filterType.title.includes('STR')
      ) {
        filterConfig = strCon
      }

      if (
        props.filterType &&
        props.filterType.key &&
        props.filterType.key.includes('total')
      ) {
        filterConfig = totalCon
      }

      if (
        props.filterType &&
        props.filterType.key &&
        props.filterType.key.includes('cohort_sites')
      ) {
        filterConfig = cohortCon
      }

      if (
        props.filterType &&
        props.filterType.key &&
        props.filterType.key.includes('case_control')
      ) {
        filterConfig = caseCon
      }

      if (pageType === 'sample') {
        filterConfig = filterConfig.filter(
          (item) => item.name !== t('Variant Sources')
        )
      }

      if (
        props.filterType &&
        props.filterType.key &&
        props.filterType.key.includes('big_family')
      ) {
        filterConfig = filterConfig
          .filter((item) => item.name !== t('Variation mass value'))
          .filter((item) => item.name !== t('Allele fraction'))
      }

      if (props.analysisInfo && props.analysisInfo.pipelineVersion) {
        filterConfig = glsSnvCon

        if (
          props.filterType &&
          props.filterType.title &&
          props.filterType.title.includes('CNV')
        ) {
          filterConfig = glsCnvCon

          if (!props.analysisInfo?.hasSCIP) {
            filterConfig = filterConfig.filter(
              (item) => !item.key?.includes('scip_')
            )
          }
        }

        if (
          props.filterType &&
          props.filterType.title &&
          props.filterType.title.includes('SV')
        ) {
          filterConfig = glsSvCon
        }
      }

      setConfig(filterConfig)
    }

    // React.useEffect(() => {
    //   //
    //   if (
    //     pageType === 'sample' &&
    //     props.filterType &&
    //     props.filterType.key &&
    //     props.filterType.key === '0'
    //   ) {
    //     const list = config.map((item) => {
    //       if (item.name === t('phenotype')) {
    //         item.value.phenotypes = []

    //         item.open = true
    //       }

    //       return item
    //     })

    //     setConfig(list)

    //     //
    //   } else {
    //     const list = config.map((item) => {
    //       if (item.name === t('phenotype')) {
    //         item.value.phenotypes = item.value.phenotypes.length
    //           ? item.value.phenotypes
    //           : getTerms(samples?.terms ?? [])

    //         item.open = true
    //       }

    //       return item
    //     })

    //     setConfig(list)
    //   }
    // }, [props.filterType, samples])

    const [machineList, setList] = React.useState([
      {
        input: '',
        select: 'symptom',
        key: 0
      }
    ])

    const { data: genePanel } = useQuery<GenePanel[]>(
      ['genePanel'],
      async () =>
        await getGenePanel({
          pageNum: 1,
          pageSize: 1000
        }),
      {
        keepPreviousData: true
      }
    )
    const { data: geneSets } = useQuery<GeneSets[]>(
      ['geneSets'],
      async () =>
        await getGeneSets({
          pageNum: 1,
          pageSize: 1000
        }),
      {
        keepPreviousData: true
      }
    )

    if (pageType === 'sample') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { data: samples } = useQuery<Sample>(
        ['samples'],
        async () => await fetchSampleById(id),
        {
          keepPreviousData: true,
          onSuccess: (data) => {
            const list = config.map((item) => {
              // if (item.name === t('phenotype')) {
              //   item.value.phenotypes = item.value.phenotypes.length
              //     ? item.value.phenotypes
              //     : getTerms(data?.terms)

              //   item.open = true
              // }

              return item
            })

            setConfig(list)

            setSample(data)
          }
        }
      )
    } else {
      //analysis
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { data: analysis } = useQuery({
        queryKey: ['analyzeInfoByAnalysisId', id],
        queryFn: () => fetchAnalyzeInfoByAnalysisId(id),
        keepPreviousData: true,
        onSuccess: (data: any) => {
          if (data && data.list && Array.isArray(data.list)) {
            const terms: any[] = []

            data.list.map((items: { analysisSamples: { terms: any }[] }) => {
              items.analysisSamples &&
                items.analysisSamples.map((item: { terms: any }) => {
                  if (item && item.terms) terms.push(getTerms(item.terms))
                })
            })

            const list = config.map((item) => {
              if (item.name === t('phenotype')) {
                item.value.phenotypes =
                  item.value.phenotypes && item.value.phenotypes.length
                    ? item.value.phenotypes
                    : unique(terms.flat(), 'title')

                item.open = true
              }

              return item
            })

            setConfig(list)
          }
        }
      })
    }

    const Translate = useMutation({
      mutationFn: async (data: TranslateDto) => await translate(data),
      onSuccess: (data, params, context) => {
        //post返回的结果
        // if (params.sourceLanguage === 'zh')
        //   GetTermByClinicalInfo.mutateAsync({
        //     clinicalInfo: data
        //   })
      }
    })

    const getGeneByClinicalSynopsis = useMutation({
      mutationFn: async (data: string[]) =>
        await getGeneByOmimPhenotypes({
          phenotypes: data
        })
    })

    const fetchGeneByHpoIds = useMutation({
      mutationFn: async (data: string[]) =>
        await getGeneByHpoIds({
          hpoIds: data
        })
    })

    React.useEffect(() => {
      setConfig(filterConfig)
    }, [filterConfig.length])

    React.useEffect(() => {
      if (filterConfig && config && config[0].name !== filterConfig[0].name) {
        // config.map((item) => {
        //   const temp = filterConfig.find((i) => i.key === item.key)

        //   if (temp) {
        //     item.name = temp.name
        //   }

        //   return config
        // })

        setConfig(filterConfig)
      }
    }, [filterConfig])

    React.useImperativeHandle(ref, () => {
      return {
        machineList,
        config,
        setConfig,
        reset
      }
    })

    return (
      <React.Fragment>
        <List
          sx={{
            width: '100%',
            overflow: 'auto',
            backgroundColor: bgColor,
            height: '100%',
            color: color,
            pt: 0,
            pb: 0
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          {config &&
            config?.map((items) => {
              return (
                <React.Fragment key={items.name}>
                  <ListItemButton
                    onClick={() => {
                      const list = config.map((item) => {
                        if (item.name === items.name) item.open = !item.open

                        // if (item.name === t('phenotype') && item.open)
                        //   item.value.phenotypes = item.value.phenotypes.length
                        //     ? item.value.phenotypes
                        //     : getTerms(sample?.terms)

                        return item
                      })

                      setConfig(list)
                    }}
                    sx={{
                      ':hover': {
                        backgroundColor: 'rgba(58, 53, 65, 0.24)'
                      },
                      bgcolor: props.bgColor ? props.bgColor : 'white'
                    }}
                  >
                    {items.open ? <ChevronDown /> : <ChevronRight />}

                    <ListItemText>
                      <Typography
                        sx={{
                          fontSize: '14px',
                          color: color
                        }}
                      >
                        {items.name}
                      </Typography>
                    </ListItemText>
                  </ListItemButton>

                  <Collapse in={items.open} timeout="auto" unmountOnExit>
                    {items.name === t('chromosome') ? (
                      <>
                        <Stack>
                          <Item>
                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <AutocompleteColor
                                size="small"
                                multiple
                                id="tags-outlined"
                                options={chromosome}
                                getOptionLabel={(option: any) => option.title}
                                filterSelectedOptions
                                renderInput={(params) => (
                                  <TextFieldColor
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t('chromosome')}
                                  />
                                )}
                                value={items.value.chrom}
                                onChange={(e: any, v: any) => {
                                  handleListChange(
                                    unique(
                                      v.map((item: any) => item),
                                      'key'
                                    ),
                                    'chrom',
                                    items
                                  )
                                }}
                              />
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                name="posStart"
                                size="small"
                                label={t('posStart')}
                                value={items.value.posStart}
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                name="posEnd"
                                size="small"
                                label={t('posEnd')}
                                value={items.value.posEnd}
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Item>
                        </Stack>
                      </>
                    ) : items.name === t('gene') ? (
                      <>
                        <Stack>
                          <Item>
                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <AutocompleteColor
                                size="small"
                                multiple
                                id="tags-outlined"
                                options={genePanel as readonly GenePanel[]}
                                getOptionLabel={(option: any) =>
                                  `${option.panelName}`
                                }
                                filterSelectedOptions
                                renderInput={(params) => (
                                  <TextFieldColor
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t('Choose gene panel')}
                                  />
                                )}
                                renderOption={(props, option: any) => (
                                  <li
                                    {...props}
                                    style={{
                                      fontSize: '0.875rem',
                                      wordBreak: 'break-all',
                                      wordWrap: 'break-word'
                                    }}
                                  >
                                    {option.panelName}
                                  </li>
                                )}
                                onChange={(e: any, v: any) => {
                                  //

                                  handleListChange(v, 'genePanelSet', items)

                                  if (!v.length)
                                    handleListChange(
                                      Array.from(new Set([])),
                                      'geneNameIn',
                                      items
                                    )
                                  else {
                                    const geneNames = v
                                      .map((item: { geneNames: any }) =>
                                        item.geneNames.split(',')
                                      )
                                      .flat()

                                    geneNames.map((item: string) => {
                                      if (
                                        !geneName_List.some((i) => i === item)
                                      )
                                        geneName_List.push(item)
                                    })

                                    handleListChange(
                                      Array.from(
                                        new Set([
                                          ...(items.value.geneNameIn ?? []),
                                          ...geneNames
                                        ])
                                      ),
                                      'geneNameIn',
                                      items
                                    )
                                  }
                                }}
                                value={items.value.genePanelSet}
                              />
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <AutocompleteColor
                                size="small"
                                multiple
                                id="tags-outlined"
                                options={geneName_List}
                                getOptionLabel={(option: any) => option}
                                filterSelectedOptions
                                renderInput={(params) => {
                                  return (
                                    <TextFieldColor
                                      {...params}
                                      InputLabelProps={{ shrink: true }}
                                      label={t('Enter gene name')}
                                      onChange={(e) => {
                                        const arrValue = e.target.value
                                          .split(' ')
                                          .join(',')
                                          .split(',')

                                        arrValue
                                          .filter((item) => item)
                                          .forEach((item) => {
                                            if (
                                              geneName_List.find(
                                                (i) => i === item
                                              )
                                            ) {
                                              //
                                            } else {
                                              geneName_List.push(
                                                item.toUpperCase()
                                              )
                                            }
                                          })

                                        if (
                                          e.target.value.includes(',') ||
                                          e.target.value.includes(' ')
                                        ) {
                                          handleListChange(
                                            Array.from(
                                              new Set([
                                                ...arrValue.filter(
                                                  (item) => item
                                                ),
                                                ...(items.value.geneNameIn ??
                                                  [])
                                              ])
                                            ),
                                            'geneNameIn',
                                            items
                                          )
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        //

                                        if (e.key === 'Enter') {
                                          handleListChange(
                                            Array.from(
                                              new Set([
                                                geneName_List[
                                                  geneName_List.length - 1
                                                ].toUpperCase(),
                                                ...(items.value.geneNameIn ??
                                                  [])
                                              ])
                                            ).filter((item) => item),
                                            'geneNameIn',
                                            items
                                          )

                                          geneName_List = []
                                        }
                                      }}
                                    />
                                  )
                                }}
                                value={items.value.geneNameIn ?? []}
                                onChange={(e: any, v: any) => {
                                  handleListChange(
                                    v.map((item: any) => item),
                                    'geneNameIn',
                                    items
                                  )

                                  geneName_List = []
                                }}
                              />
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <AutocompleteColor
                                size="small"
                                multiple
                                id="tags-outlined"
                                options={geneNameOut_List}
                                getOptionLabel={(option: any) => option}
                                filterSelectedOptions
                                renderInput={(params) => (
                                  <TextFieldColor
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      const arrValue = e.target.value
                                        .split(' ')
                                        .join(',')
                                        .split(',')

                                      arrValue
                                        .filter((item) => item)
                                        .forEach((item) => {
                                          if (
                                            geneNameOut_List.find(
                                              (i) => i === item
                                            )
                                          ) {
                                            //
                                          } else {
                                            geneNameOut_List.push(item)
                                          }
                                        })

                                      if (
                                        e.target.value.includes(',') ||
                                        e.target.value.includes(' ')
                                      ) {
                                        handleListChange(
                                          Array.from(
                                            new Set([
                                              ...arrValue.filter(
                                                (item) => item
                                              ),
                                              ...(items.value.geneNameOut ?? [])
                                            ])
                                          ),
                                          'geneNameOut',
                                          items
                                        )
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        handleListChange(
                                          Array.from(
                                            new Set([
                                              geneNameOut_List[
                                                geneNameOut_List.length - 1
                                              ],
                                              ...(items.value.geneNameOut ?? [])
                                            ])
                                          ).filter((item) => item),
                                          'geneNameOut',
                                          items
                                        )

                                        geneNameOut_List = []
                                      }
                                    }}
                                    label={t(
                                      'The name of the gene to be filtered'
                                    )}
                                  />
                                )}
                                value={items.value.geneNameOut ?? []}
                                onChange={(e: any, v: any) => {
                                  handleListChange(
                                    v.map((item: any) => item),
                                    'geneNameOut',
                                    items
                                  )

                                  geneNameOut_List = []
                                }}
                              />
                            </FormControl>
                          </Item>
                        </Stack>
                      </>
                    ) : items.name === t('RU') ? (
                      <>
                        <Stack>
                          <Item>
                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <AutocompleteColor
                                size="small"
                                multiple
                                id="tags-outlined"
                                options={RU_List}
                                getOptionLabel={(option: any) => option}
                                filterSelectedOptions
                                renderInput={(params) => {
                                  return (
                                    <TextFieldColor
                                      {...params}
                                      InputLabelProps={{ shrink: true }}
                                      label={t('Enter RU value')}
                                      onChange={(e) => {
                                        const arrValue = e.target.value
                                          .split(' ')
                                          .join(',')
                                          .split(',')

                                        arrValue
                                          .filter((item) => item)
                                          .forEach((item) => {
                                            if (
                                              RU_List.find((i) => i === item)
                                            ) {
                                              //
                                            } else {
                                              RU_List.push(item.toUpperCase())
                                            }
                                          })

                                        if (
                                          e.target.value.includes(',') ||
                                          e.target.value.includes(' ')
                                        ) {
                                          handleListChange(
                                            Array.from(
                                              new Set([
                                                ...arrValue.filter(
                                                  (item) => item
                                                ),
                                                ...(items.value.RU ?? [])
                                              ])
                                            ),
                                            'RU',
                                            items
                                          )
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        //

                                        if (e.key === 'Enter') {
                                          handleListChange(
                                            Array.from(
                                              new Set([
                                                RU_List[
                                                  RU_List.length - 1
                                                ].toUpperCase(),
                                                ...(items.value.RU ?? [])
                                              ])
                                            ).filter((item) => item),
                                            'RU',
                                            items
                                          )

                                          RU_List = []
                                        }
                                      }}
                                    />
                                  )
                                }}
                                value={items.value.RU ?? []}
                                onChange={(e: any, v: any) => {
                                  handleListChange(
                                    v.map((item: any) => item),
                                    'RU',
                                    items
                                  )

                                  RU_List = []
                                }}
                              />
                            </FormControl>
                          </Item>
                        </Stack>
                      </>
                    ) : items.name === t('genetic-way') ? (
                      <>
                        <Stack>
                          <Item>
                            <ToggleButtonGroupColor
                              aria-label="device"
                              size="small"
                              value={items.value.inheritance}
                              onChange={(e, value) => {
                                handleListChange(value, 'inheritance', items)
                              }}
                              sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                width: '100%',
                                justifyContent: 'center'
                              }}
                            >
                              {inheritance.map((item) => {
                                return (
                                  <ToggleButtonColor
                                    value={item}
                                    aria-label={item}
                                  >
                                    {item}
                                  </ToggleButtonColor>
                                )
                              })}
                            </ToggleButtonGroupColor>

                            {/* <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >

                              <AutocompleteColor
                                size="small"
                                multiple
                                id="tags-outlined"
                                options={inheritance}
                                getOptionLabel={(option: any) => `${option}`}
                                filterSelectedOptions
                                renderInput={(params) => (
                                  <TextFieldColor
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t('Inheritance')}
                                  />
                                )}
                                onChange={(e: any, v: any) => {
                                  handleListChange(v, 'inheritance', items)
                                }}
                                value={items.value.inheritance}
                              />
                            </FormControl> */}
                          </Item>
                        </Stack>
                      </>
                    ) : items.name === `Clinvar ${t('Publication')}` ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.hasPubmed}
                            onChange={(e: any, value) => {
                              handleListChange(value, 'hasPubmed', items)
                            }}
                          >
                            <ToggleButtonColor
                              value="pubmed"
                              aria-label="pubmed"
                            >
                              Has {`Clinvar ${t('Publication')}`}
                            </ToggleButtonColor>
                          </ToggleButtonGroupColor>
                        </Item>
                      </Stack>
                    ) : items.name === 'ROH' ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.is_ROH}
                            onChange={(e: any, value) => {
                              handleListChange(value, 'is_ROH', items)
                            }}
                          >
                            <ToggleButtonColor value="roh" aria-label="roh">
                              Apply ROH
                            </ToggleButtonColor>
                          </ToggleButtonGroupColor>
                        </Item>
                      </Stack>
                    ) : items.name === 'Loss of Function' ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.is_loss_of_function}
                            onChange={(e: any, value) => {
                              handleListChange(
                                value,
                                'is_loss_of_function',
                                items
                              )
                            }}
                          >
                            <ToggleButtonColor
                              value="loss_of_function"
                              aria-label="loss_of_function"
                            >
                              Apply Loss of Function
                            </ToggleButtonColor>
                          </ToggleButtonGroupColor>
                        </Item>
                      </Stack>
                    ) : items.name === `CNV ${t('Highlights')}` ? (
                      <Stack>
                        <Item>
                          <FormGroup>
                            <FormControlLabel
                              onChange={(e: any, value) => {
                                handleListChange(
                                  value,
                                  'hasPositiveHighlight',
                                  items
                                )
                              }}
                              control={<Switch />}
                              label="Positive"
                              labelPlacement="start"
                              sx={{
                                justifyContent: 'start'
                              }}
                            />

                            <FormControlLabel
                              onChange={(e: any, value) => {
                                handleListChange(
                                  value,
                                  'hasNegativeHighlight',
                                  items
                                )
                              }}
                              control={<Switch />}
                              label="Negative"
                              labelPlacement="start"
                              sx={{
                                justifyContent: 'start'
                              }}
                            />
                          </FormGroup>
                        </Item>
                      </Stack>
                    ) : items.key === 'phenotypes' ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '90%' }}
                            size="small"
                            fullWidth
                          >
                            <ChinahpoSearch
                              termList={items.value.phenotypes}
                              fn={(query: any) => {
                                handleListChange(query, 'phenotypes', items)

                                return query
                              }}
                              sx={{
                                flex: 1,
                                width: '100%'
                              }}
                              sampleId={id}
                              isBlack
                              disabledOMIM
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.key === 'glsphenotypes' ||
                      items.key === 'glsphenotypesCNV' ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '90%' }}
                            size="small"
                            fullWidth
                          >
                            <ChinahpoSearch
                              termList={items.value[items.key]}
                              fn={async (query: any) => {
                                handleListChange(query, items.key, items)
                                console.log(query)
                                const arr = query
                                  .map((i: any) => i.hpo_code)
                                  .filter((i: any) => i) as string[]
                                if (!arr.length) return query
                                const data =
                                  await fetchGeneByHpoIds.mutateAsync(arr)
                                if (data && data.length) {
                                  const genes = data
                                    .map((i: any) => i.gene_names)
                                    .flat()
                                  if (genes && genes.length) {
                                    handleListChange(
                                      [...genes],
                                      'geneNameIn',
                                      items
                                    )
                                  }
                                }
                                return query
                              }}
                              sx={{
                                flex: 1,
                                width: '100%'
                              }}
                              sampleId={id}
                              isBlack
                              disabledOMIM
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('area') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              options={geneSets as readonly GeneSets[]}
                              getOptionLabel={(option: any) => `${option.name}`}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextFieldColor
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  label={t('Bed')}
                                />
                              )}
                              renderOption={(props, option: any) => (
                                <li
                                  {...props}
                                  style={{
                                    fontSize: '0.875rem',
                                    wordBreak: 'break-all',
                                    wordWrap: 'break-word'
                                  }}
                                >
                                  {option.name}
                                </li>
                              )}
                              onChange={(e: any, v: any) => {
                                handleListChange(v, 'geneSet', items)
                              }}
                              value={items.value.geneSet}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('Reads depth') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.readDepthOperator}
                              name="readDepthOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 120, marginLeft: '20px' }}
                              value={items.value.readDepthValue}
                              label="readDepthValue"
                              name="readDepthValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('Index') ? (
                      <Item>
                        <Box px={2} pr={4}>
                          <Stack
                            direction={'row'}
                            justifyContent="space-between"
                            alignItems={'center'}
                          >
                            <FormControl sx={{ m: 1 }} size="small">
                              <Typography color={color}>{`${t(
                                'gls'
                              )} Index ≥`}</Typography>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.indexMin}
                                label="indexMin"
                                name="indexMin"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Stack>

                          <Stack
                            direction={'row'}
                            justifyContent="space-between"
                            alignItems={'center'}
                          >
                            <FormControl sx={{ m: 1 }} size="small">
                              <Typography color={color}>{`${t(
                                'gls'
                              )} Index ≤`}</Typography>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.indexMax}
                                label="indexMax"
                                name="indexMax"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Stack>

                          <Stack
                            direction={'row'}
                            justifyContent="space-between"
                            alignItems={'center'}
                          >
                            <FormControl sx={{ m: 1 }} size="small">
                              <Typography color={color}>{`${t(
                                'organization'
                              )} Index ≥`}</Typography>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.organizationIndexMin}
                                label="indexMin"
                                name="organizationIndexMin"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Stack>

                          <Stack
                            direction={'row'}
                            justifyContent="space-between"
                            alignItems={'center'}
                          >
                            <FormControl sx={{ m: 1 }} size="small">
                              <Typography color={color}>{`${t(
                                'organization'
                              )} Index ≤`}</Typography>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.organizationIndexMax}
                                label="indexMax"
                                name="organizationIndexMax"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Stack>

                          <Stack
                            direction={'row'}
                            justifyContent="space-between"
                            alignItems={'center'}
                          >
                            <FormControl sx={{ m: 1 }} size="small">
                              <Typography color={color}>{`${t(
                                'owner'
                              )} Index ≥`}</Typography>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.ownerIndexMin}
                                label="indexMin"
                                name="ownerIndexMin"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Stack>

                          <Stack
                            direction={'row'}
                            justifyContent="space-between"
                            alignItems={'center'}
                          >
                            <FormControl sx={{ m: 1 }} size="small">
                              <Typography color={color}>{`${t(
                                'owner'
                              )} Index ≤`}</Typography>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.ownerIndexMax}
                                label="indexMax"
                                name="ownerIndexMax"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Stack>
                        </Box>
                      </Item>
                    ) : items.name === t('Allele fraction') ? (
                      <Item>
                        <Stack
                          direction={'row'}
                          justifyContent={'space-evenly'}
                          alignItems={'center'}
                          pl={1}
                        >
                          <Typography color={color}>INDEL</Typography>

                          <Box>
                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.indelOperator}
                                name="indelOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                size="small"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '7.5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.indelValue}
                                label="indelValue"
                                name="indelValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Box>
                        </Stack>

                        <Stack
                          direction={'row'}
                          justifyContent={'space-evenly'}
                          alignItems={'center'}
                          pl={1}
                        >
                          <Typography color={color}>SNV</Typography>

                          <Box>
                            <FormControl
                              sx={{ m: 1, width: '5rem' }}
                              size="small"
                            >
                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.snvOperator}
                                name="snvOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                placeholder="123"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '7.5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.snvValue}
                                label="snvValue"
                                name="snvValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </Box>
                        </Stack>
                      </Item>
                    ) : items.name === t('Variation mass value') ? (
                      <Item>
                        <FormControl sx={{ m: 1, width: '5rem' }} size="small">
                          <Typography color={color}>QUAL ≥</Typography>
                        </FormControl>

                        <FormControl sx={{ m: 1, width: '10rem' }} size="small">
                          <TextFieldColor
                            id="outlined-number"
                            InputLabelProps={{
                              shrink: true
                            }}
                            size="small"
                            value={items.value.qualMin}
                            label="qualMin"
                            name="qualMin"
                            onChange={(e) => {
                              if (Number.isFinite(Number(e.target.value))) {
                                const value = Number(e.target.value)
                                  ? Number(e.target.value)
                                  : null

                                handleListChange(value, e.target.name, items)
                              }
                            }}
                          />
                        </FormControl>

                        <FormControl sx={{ m: 1, width: '5rem' }} size="small">
                          <Typography color={color}>QUAL ≤</Typography>
                        </FormControl>

                        <FormControl sx={{ m: 1, width: '10rem' }} size="small">
                          <TextFieldColor
                            id="outlined-number"
                            InputLabelProps={{
                              shrink: true
                            }}
                            size="small"
                            value={items.value.qualMax}
                            label="qualMax"
                            name="qualMax"
                            onChange={(e) => {
                              if (Number.isFinite(Number(e.target.value))) {
                                const value = Number(e.target.value)
                                  ? Number(e.target.value)
                                  : null

                                handleListChange(value, e.target.name, items)
                              }
                            }}
                          />
                        </FormControl>
                      </Item>
                    ) : items.name === t('Zygosity') ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.zygosity}
                            onChange={(e, value) => {
                              handleListChange(value, 'zygosity', items)
                            }}
                            exclusive
                          >
                            <ToggleButtonColor value="" aria-label={t('any')}>
                              {t('any')}
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value="homozygote"
                              aria-label={t('homozygote')}
                            >
                              {t('homozygote')}
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value="heterozygote"
                              aria-label={t('heterozygote')}
                            >
                              {t('heterozygote')}
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value={'compound hets'}
                              aria-label={t('recombination')}
                            >
                              {t('recombination')}
                            </ToggleButtonColor>
                          </ToggleButtonGroupColor>
                        </Item>
                      </Stack>
                    ) : items.name === `CNV ${t('Type')}` ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.SVType}
                            onChange={(e, value) => {
                              handleListChange(value, 'SVType', items)
                            }}
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '100%',
                              justifyContent: 'center'
                            }}
                          >
                            <ToggleButtonColor
                              value="DEL"
                              aria-label={t('del')}
                            >
                              {i18n.language === 'zh'
                                ? `DEL(${t('del')})`
                                : 'DEL'}
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value="DUP"
                              aria-label={t('dup')}
                            >
                              {i18n.language === 'zh'
                                ? `DUP(${t('dup')})`
                                : 'DUP'}
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value="INS"
                              aria-label={t('ins')}
                            >
                              {i18n.language === 'zh'
                                ? `INS(${t('ins')})`
                                : 'INS'}
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value={'INV'}
                              aria-label={t('inv')}
                            >
                              {i18n.language === 'zh'
                                ? `INV(${t('inv')})`
                                : 'INV'}
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value={'BND'}
                              aria-label={t('bnd')}
                            >
                              {i18n.language === 'zh'
                                ? `BND(${t('bnd')})`
                                : 'BND'}
                            </ToggleButtonColor>
                          </ToggleButtonGroupColor>
                        </Item>
                      </Stack>
                    ) : items.name === `${t('Copy number filtering')}` ? (
                      <>
                        <Stack>
                          <Item>
                            <FormControl
                              sx={{ m: 1, width: '12.5rem' }}
                              size="small"
                            >
                              <AutocompleteColor
                                size="small"
                                id="tags-outlined"
                                options={copyList}
                                getOptionLabel={(option: any) => option.title}
                                filterSelectedOptions
                                renderInput={(params) => (
                                  <TextFieldColor
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t('Copy Number(CN)')}
                                  />
                                )}
                                value={items.value.chrom}
                                onChange={(e: any, v: any) => {
                                  //

                                  handleListChange(v.key, 'CopyNumber', items)
                                }}
                              />
                            </FormControl>
                          </Item>
                        </Stack>
                      </>
                    ) : items.name === t('Population frequency') ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.gnomAD}
                            onChange={(e, value) => {
                              handleListChange(value, 'gnomAD', items)
                            }}
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '100%',
                              justifyContent: 'center'
                            }}
                          >
                            {props.analysisInfo.pipelineVersion ? (
                              <>
                                <ToggleButtonColor
                                  value="gnomade_af"
                                  aria-label="gADE_ALL"
                                >
                                  gADE_ALL
                                </ToggleButtonColor>

                                <ToggleButtonColor
                                  value="gnomadg_af"
                                  aria-label="gADG_ALL"
                                >
                                  gADG_ALL
                                </ToggleButtonColor>

                                <ToggleButtonColor
                                  value="wbbc_af"
                                  aria-label="WBBC"
                                >
                                  WBBC
                                </ToggleButtonColor>
                              </>
                            ) : (
                              <>
                                <ToggleButtonColor
                                  value="gnomAD_exome_ALL"
                                  aria-label="gAD_ALL"
                                >
                                  gAD_ALL
                                </ToggleButtonColor>

                                <ToggleButtonColor
                                  value="gnomAD_exome_EAS"
                                  aria-label="gAD_EAS"
                                >
                                  gAD_EAS
                                </ToggleButtonColor>
                              </>
                            )}
                          </ToggleButtonGroupColor>

                          <FormControl
                            sx={{ m: 1, width: '5rem', marginTop: 2 }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.gnomADOperator}
                              name="gnomADOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={''}></MenuItem>

                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{ m: 1, width: '10rem', marginTop: 2 }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              value={items.value.gnomADValue}
                              label="gnomADValue"
                              name="gnomADValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('RSId') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              options={rsId_List}
                              getOptionLabel={(option: any) => option}
                              filterSelectedOptions
                              renderInput={(params) => {
                                return (
                                  <TextFieldColor
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label={t('Enter rsId')}
                                    onChange={(e) => {
                                      const arrValue = e.target.value
                                        .split(' ')
                                        .join(',')
                                        .split(',')

                                      arrValue
                                        .filter((item) => item)
                                        .forEach((item) => {
                                          if (
                                            rsId_List.find((i) => i === item)
                                          ) {
                                            //
                                          } else {
                                            rsId_List.push(item.toLowerCase())
                                          }
                                        })

                                      if (
                                        e.target.value.includes(',') ||
                                        e.target.value.includes(' ')
                                      ) {
                                        handleListChange(
                                          Array.from(
                                            new Set([
                                              ...arrValue.filter(
                                                (item) => item
                                              ),
                                              ...(items.value.rsId ?? [])
                                            ])
                                          ),
                                          'rsId',
                                          items
                                        )
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      //

                                      if (e.key === 'Enter') {
                                        handleListChange(
                                          Array.from(
                                            new Set([
                                              rsId_List[
                                                rsId_List.length - 1
                                              ].toLowerCase(),
                                              ...(items.value.rsId ?? [])
                                            ])
                                          ).filter((item) => item),
                                          'rsId',
                                          items
                                        )

                                        rsId_List = []
                                      }
                                    }}
                                  />
                                )
                              }}
                              value={items.value.rsId ?? []}
                              onChange={(e: any, v: any) => {
                                handleListChange(
                                  v.map((item: any) => item),
                                  'rsId',
                                  items
                                )

                                rsId_List = []
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name ===
                      `GLS ${t('pathogenic classification')}` ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroup
                            aria-label="device"
                            size="small"
                            value={items.value.classification}
                            onChange={(e, value) => {
                              handleListChange(value, 'classification', items)
                            }}
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '100%',
                              justifyContent: 'center'
                            }}
                          >
                            {GLSGrading.map((item) => {
                              return (
                                <ToggleButton
                                  key={item.key}
                                  value={item.key}
                                  sx={{
                                    ':hover': {
                                      backgroundColor: item.hoverColor
                                    },
                                    backgroundColor:
                                      items.value.classification &&
                                      items.value.classification.some(
                                        (i: string) => i === item.key
                                      )
                                        ? `${item.color} !important`
                                        : bgColor,
                                    color: color,
                                    borderColor: `${color} !important`
                                  }}
                                >
                                  {item.title}
                                </ToggleButton>
                              )
                            })}
                          </ToggleButtonGroup>
                        </Item>
                      </Stack>
                    ) : items.name === `${t('rating')}` ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroup
                            aria-label="device"
                            size="small"
                            value={items.value.ccnv_classification}
                            onChange={(e, value) => {
                              if (items.key === 'sv_classification') {
                                handleListChange(
                                  value,
                                  'sv_classification',
                                  items
                                )
                              } else
                                handleListChange(
                                  value,
                                  'ccnv_classification',
                                  items
                                )
                            }}
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '100%',
                              justifyContent: 'center'
                            }}
                          >
                            {ACMGClassification.map((item) => {
                              return (
                                <ToggleButton
                                  key={item.key}
                                  value={item.key}
                                  sx={{
                                    ':hover': {
                                      backgroundColor: item.hoverColor
                                    },
                                    backgroundColor:
                                      items.value.ccnv_classification &&
                                      items.value.ccnv_classification.some(
                                        (i: string) => i === item.key
                                      )
                                        ? `${item.color} !important`
                                        : items.value.sv_classification &&
                                          items.value.sv_classification.some(
                                            (i: string) => i === item.key
                                          )
                                        ? `${item.color} !important`
                                        : bgColor,
                                    color: color,
                                    borderColor: `${color} !important`
                                  }}
                                >
                                  {item.title}
                                </ToggleButton>
                              )
                            })}
                          </ToggleButtonGroup>
                        </Item>
                      </Stack>
                    ) : items.name === t('CLINVAR_clnsig') ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.CLINVAR_clnsig_final}
                            onChange={(e, value) => {
                              handleListChange(
                                value,
                                'CLINVAR_clnsig_final',
                                items
                              )
                            }}
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '99%',
                              justifyContent: 'center'
                            }}
                          >
                            <ToggleButtonColor
                              value="PAT"
                              aria-label="Pathogenic"
                            >
                              Pathogenic
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value="LP"
                              aria-label="Likely pathogenic"
                            >
                              Likely Pathogenic
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value="VUS"
                              aria-label="Uncertain significance"
                            >
                              Uncertain Significance
                            </ToggleButtonColor>

                            <ToggleButtonColor
                              value="LB"
                              aria-label="Likely benign"
                            >
                              Likely Benign
                            </ToggleButtonColor>

                            <ToggleButtonColor value="BEN" aria-label="Benign">
                              Benign
                            </ToggleButtonColor>

                            <ToggleButtonColor value="CONF" aria-label="Confl">
                              Conf
                            </ToggleButtonColor>

                            <ToggleButtonColor value="." aria-label="None">
                              None
                            </ToggleButtonColor>
                          </ToggleButtonGroupColor>
                        </Item>
                      </Stack>
                    ) : items.name === t('Variant Sources') ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroupColor
                            aria-label="device"
                            size="small"
                            value={items.value.sampleSource}
                            onChange={(e, value) => {
                              handleListChange(value, 'sampleSource', items)
                            }}
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '99%',
                              justifyContent: 'center'
                            }}
                          >
                            {props.analysisInfo &&
                              props.analysisInfo.samples.map((item: any) => {
                                return (
                                  <ToggleButtonColor
                                    key={`${item.id}/${item.type}`}
                                    value={`${item.id}/${item.type}`}
                                    aria-label={t(item.type)}
                                    sx={{
                                      wordBreak: 'break-all',
                                      width: '250px'
                                    }}
                                  >
                                    {`Id:${item.id}:${item.name}:${t(
                                      item.type
                                    )}`}
                                  </ToggleButtonColor>
                                )
                              })}
                          </ToggleButtonGroupColor>
                        </Item>
                      </Stack>
                    ) : items.name === t('In-Silico predictions') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '8.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                F score
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.fscoreOperator}
                                name="fscoreOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="F score"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '8rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.fscoreValue}
                                label="score"
                                name="fscoreValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '8.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                G score
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.gscoreOperator}
                                name="gscoreOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="G score"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '8rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.gscoreValue}
                                label="score"
                                name="gscoreValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '8.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                Revel
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.revelOperator}
                                name="revelOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="Revel"
                              >
                                <MenuItem value={'gte.'}>≥包含无</MenuItem>

                                <MenuItem value={'lte.'}>≤包含无</MenuItem>

                                <MenuItem value={'gte'}>≥不包含无</MenuItem>

                                <MenuItem value={'lte'}>≤不包含无</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '8rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.revelValue}
                                label="score"
                                name="revelValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '8.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                AlphaM
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.alphaMOperator}
                                name="alphaMOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="AlphaM"
                              >
                                <MenuItem value={'gte.'}>≥包含无</MenuItem>

                                <MenuItem value={'lte.'}>≤包含无</MenuItem>

                                <MenuItem value={'gte'}>≥不包含无</MenuItem>

                                <MenuItem value={'lte'}>≤不包含无</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '8rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.alphaMValue}
                                label="score"
                                name="alphaMValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '8.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                SpliceAI
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.spliceAIOperator}
                                name="spliceAIOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="SpliceAI"
                              >
                                <MenuItem value={'gte.'}>≥包含无</MenuItem>

                                <MenuItem value={'lte.'}>≤包含无</MenuItem>

                                <MenuItem value={'gte'}>≥不包含无</MenuItem>

                                <MenuItem value={'lte'}>≤不包含无</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '8rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.spliceAIValue}
                                label="score"
                                name="spliceAIValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '16.25rem',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '3.75rem' }}
                              size="small"
                            >
                              <ToggleButtonGroupColor
                                aria-label="device"
                                size="small"
                                value={items.value.insilico}
                                onChange={(e, value) => {
                                  handleListChange(value, 'insilico', items)
                                }}
                              >
                                <ToggleButtonColor
                                  value="CADD"
                                  aria-label="CADD"
                                >
                                  CADD
                                </ToggleButtonColor>
                              </ToggleButtonGroupColor>
                            </FormControl>

                            <FormControl sx={{ m: 1 }} size="small">
                              <Typography color={color}>&gt;</Typography>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '7.5rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.CADDValue}
                                name="CADDValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('gnomAD SV & Clinvar SV') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '6.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                Overlap Rate
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.scipOverlapRateOperator}
                                name="scipOverlapRateOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="Overlap Rate"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '10rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.scipOverlapRateValue}
                                label="score"
                                name="scipOverlapRateValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '6.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                GnomAd Overlap Rate
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={
                                  items.value.scipGnomAdOverlapRateOperator
                                }
                                name="scipGnomAdOverlapRateOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="GnomAd Overlap Rate"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '10rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.scipGnomAdOverlapRateValue}
                                label="score"
                                name="scipGnomAdOverlapRateValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '6.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                Clinvar Overlap Rate
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={
                                  items.value.scipClinvarOverlapRateOperator
                                }
                                name="scipClinvarOverlapRateOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="Clinvar Overlap Rate"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '10rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.scipClinvarOverlapRateValue}
                                label="score"
                                name="scipClinvarOverlapRateValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('Gene info') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '6.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                Gene Overlap Rate
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.scipGeneOverlapRateOperator}
                                name="scipGeneOverlapRateOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="Operator"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '10rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.scipGeneOverlapRateValue}
                                label="score"
                                name="scipGeneOverlapRateValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '6.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                Gene Pli
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.scipGenePliOperator}
                                name="scipGenePliOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="Operator"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '10rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.scipGenePliValue}
                                label="score"
                                name="scipGenePliValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '6.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                Gene Loeuf
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.scipGeneLoeufOperator}
                                name="scipGeneLoeufOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="Operator"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '10rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.scipGeneLoeufValue}
                                label="score"
                                name="scipGeneLoeufValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>

                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              options={ScipGeneHits}
                              getOptionLabel={(option: any) => option.title}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextFieldColor
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  label={t('ScipGeneHits')}
                                />
                              )}
                              value={items.value.scipGeneHiIn}
                              onChange={(e: any, v: any) => {
                                handleListChange(
                                  unique(
                                    v.map((item: any) => item),
                                    'key'
                                  ),
                                  'scipGeneHiIn',
                                  items
                                )
                              }}
                            />
                          </FormControl>

                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              options={ScipClingenDose}
                              getOptionLabel={(option: any) => option.title}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextFieldColor
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  label={t('ScipClingenDose')}
                                />
                              )}
                              value={items.value.scipGeneTsIn}
                              onChange={(e: any, v: any) => {
                                handleListChange(
                                  unique(
                                    v.map((item: any) => item),
                                    'key'
                                  ),
                                  'scipGeneTsIn',
                                  items
                                )
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === `${t('Clingen')}` ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              options={ScipClingenDose}
                              getOptionLabel={(option: any) => option.title}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextFieldColor
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  label={t('ScipClingenHaploIn')}
                                />
                              )}
                              value={items.value.scipClingenHaploIn}
                              onChange={(e: any, v: any) => {
                                handleListChange(
                                  unique(
                                    v.map((item: any) => item),
                                    'key'
                                  ),
                                  'scipClingenHaploIn',
                                  items
                                )
                              }}
                            />
                          </FormControl>

                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              options={ScipClingenDose}
                              getOptionLabel={(option: any) => option.title}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextFieldColor
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  label={t('ScipClingenTriploIn')}
                                />
                              )}
                              value={items.value.scipClingenTriploIn}
                              onChange={(e: any, v: any) => {
                                handleListChange(
                                  unique(
                                    v.map((item: any) => item),
                                    'key'
                                  ),
                                  'scipClingenTriploIn',
                                  items
                                )
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === `ACMG ${t('rating')}` ? (
                      <Stack>
                        <Item>
                          <ToggleButtonGroup
                            aria-label="device"
                            size="small"
                            value={items.value.acmgClassification}
                            onChange={(e, value) => {
                              handleListChange(
                                value,
                                'acmgClassification',
                                items
                              )
                            }}
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '100%',
                              justifyContent: 'center'
                            }}
                          >
                            {ACMGClassification.map((item) => {
                              return (
                                <ToggleButton
                                  key={item.key}
                                  value={item.key}
                                  sx={{
                                    ':hover': {
                                      backgroundColor: item.hoverColor
                                    },
                                    backgroundColor:
                                      items.value.acmgClassification &&
                                      items.value.acmgClassification.some(
                                        (i: string) => i === item.key
                                      )
                                        ? `${item.color} !important`
                                        : bgColor,
                                    color: color,
                                    borderColor: `${color} !important`
                                  }}
                                >
                                  {item.title}
                                </ToggleButton>
                              )
                            })}
                          </ToggleButtonGroup>

                          <FormControl
                            sx={{
                              m: 1,
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <FormControl
                              sx={{ m: 1, width: '6.25rem' }}
                              size="small"
                            >
                              <InputLabel sx={{ color: `${color} !important` }}>
                                ACMG score
                              </InputLabel>

                              <SelectColor
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={items.value.acmgScoreOperator}
                                name="acmgScoreOperator"
                                onChange={(e) => {
                                  handleListChange(
                                    e.target.value,
                                    e.target.name,
                                    items
                                  )
                                }}
                                autoWidth
                                label="G score"
                              >
                                <MenuItem value={'gte'}>≥</MenuItem>

                                <MenuItem value={'lte'}>≤</MenuItem>
                              </SelectColor>
                            </FormControl>

                            <FormControl
                              sx={{ m: 1, width: '10rem' }}
                              size="small"
                            >
                              <TextFieldColor
                                id="outlined-number"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                size="small"
                                value={items.value.acmgScoreValue}
                                label="score"
                                name="acmgScoreValue"
                                onChange={(e) => {
                                  if (Number.isFinite(Number(e.target.value))) {
                                    const value = Number(e.target.value)
                                      ? Number(e.target.value)
                                      : null

                                    handleListChange(
                                      value,
                                      e.target.name,
                                      items
                                    )
                                  }
                                }}
                              />
                            </FormControl>
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.key === 'variantOption' ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              groupBy={(options: any) => options.firstLetter}
                              options={sequenceOntology}
                              getOptionLabel={(option: any) =>
                                option.value.text
                              }
                              value={items.value.sequenceOntology}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextFieldColor
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  label={t('Sequence ontology')}
                                  sx={{ color: color }}
                                />
                              )}
                              onChange={(e, v: any) => {
                                console.log(v)

                                handleListChange(v, 'sequenceOntology', items)
                              }}
                              renderGroup={(params: any) => {
                                return (
                                  <li key={params.key}>
                                    <GroupHeader
                                      onClick={() => {
                                        console.log([
                                          ...sequenceOntology.filter(
                                            (items) =>
                                              items.firstLetter === params.group
                                          ),
                                          ...items.value.sequenceOntology
                                        ])

                                        handleListChange(
                                          [
                                            ...sequenceOntology.filter(
                                              (items) =>
                                                items.firstLetter ===
                                                params.group
                                            ),
                                            ...items.value.sequenceOntology
                                          ],
                                          'sequenceOntology',
                                          items
                                        )
                                      }}
                                      sx={{
                                        cursor: 'pointer'
                                      }}
                                    >
                                      {params.group}
                                    </GroupHeader>

                                    {params.children.length &&
                                    params.children.length <= 1 ? (
                                      ''
                                    ) : (
                                      <GroupItems>{params.children}</GroupItems>
                                    )}
                                  </li>
                                )
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.key === 'tokenToLocations' ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '12.5rem' }}
                            size="small"
                          >
                            <AutocompleteColor
                              size="small"
                              multiple
                              id="tags-outlined"
                              groupBy={(options: any) => options.firstLetter}
                              options={tokenAll}
                              getOptionLabel={(option: any) =>
                                option.value.text
                              }
                              value={items.value.tokenToLocations}
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextFieldColor
                                  {...params}
                                  InputLabelProps={{ shrink: true }}
                                  label={t('Sequence ontology')}
                                  sx={{ color: color }}
                                />
                              )}
                              onChange={(e, v: any) => {
                                handleListChange(v, 'tokenToLocations', items)
                              }}
                              renderGroup={(params: any) => {
                                return (
                                  <li key={params.key}>
                                    <GroupHeader
                                      onClick={() => {
                                        handleListChange(
                                          [
                                            ...tokenAll.filter(
                                              (items) =>
                                                items.firstLetter ===
                                                params.group
                                            ),
                                            ...items.value.tokenToLocations
                                          ],
                                          'tokenToLocations',
                                          items
                                        )
                                      }}
                                      sx={{
                                        cursor: 'pointer'
                                      }}
                                    >
                                      {params.group}
                                    </GroupHeader>

                                    {params.children.length &&
                                    params.children.length <= 1 ? (
                                      ''
                                    ) : (
                                      <GroupItems>{params.children}</GroupItems>
                                    )}
                                  </li>
                                )
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('OMIM') ? (
                      <Stack>
                        <Item>
                          <FormControl sx={{ m: 1, width: '90%' }} size="small">
                            <ChinahpoSearch
                              termList={items.value.mimNumbers}
                              fn={async (query: any) => {
                                handleListChange(query, 'mimNumbers', items)
                                const arr = query
                                  .map((i: any) => i.gene)
                                  .filter((i: any) => i) as string[]
                                if (!arr.length) return query

                                const temp = config.find(
                                  (item) => item.key === 'gene'
                                )
                                if (
                                  temp?.value &&
                                  temp.value.geneNameIn &&
                                  props.analysisInfo.pipelineVersion
                                ) {
                                  const geneNameIn = temp.value.geneNameIn
                                  handleListChange(
                                    [...arr, ...geneNameIn],
                                    'geneNameIn',
                                    items
                                  )
                                }
                              }}
                              sx={{
                                flex: 1,
                                width: '100%',
                                '& .MuiAutocomplete-option': {
                                  fontSize: '12px !important'
                                }
                              }}
                              sampleId={id}
                              disabledHp
                              disabledRefersh
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('OR') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.oddsRatioOperator}
                              name="oddsRatioOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.oddsRatioValue}
                              label={t('oddsRatioValue')}
                              name="oddsRatioValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('P-value') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.pValueOperator}
                              name="pValueOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.pValueValue}
                              label={t('pValueValue')}
                              name="pValueValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('Log_Pvalue') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.logPvalueOperator}
                              name="logPvalueOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.logPvalueValue}
                              label={t('logPvalueValue')}
                              name="logPvalueValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('Count') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.countOperator}
                              name="countOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.countValue}
                              label={t('countValue')}
                              name="countValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('Hits_ratio') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.hitsRatioOperator}
                              name="hitsRatioOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.hitsRatioValue}
                              label={t('hitsRatioValue')}
                              name="hitsRatioValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('total Cases') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.totalCasesOperator}
                              name="totalCasesOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              sx={{
                                '& .MuiSelect-select': {
                                  zIndex: 10000
                                }
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.totalCasesValue}
                              label={t('totalCasesValue')}
                              name="totalCasesValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('GangStr_dp') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.gangStrDpOperator}
                              name="gangStrDpOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.gangStrDpValue}
                              label={t('gangStrDpValue')}
                              name="gangStrDpValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('GangStr_q') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.gangStrQualityOperator}
                              name="gangStrQualityOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.gangStrQualityValue}
                              label={t('gangStrQualityValue')}
                              name="gangStrQualityValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('EH_ref') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.expansionHunterRefOperator}
                              name="expansionHunterRefOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.expansionHunterRefValue}
                              label={t('expansionHunterRefValue')}
                              name="expansionHunterRefValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('total Controls') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.totalControlsOperator}
                              name="totalControlsOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'gt'}>{'>'}</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>

                              <MenuItem value={'lt'}>{'<'}</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.totalControlsValue}
                              label={t('totalControlsValue')}
                              name="totalControlsValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : items.name === t('Length') ? (
                      <Stack>
                        <Item>
                          <FormControl
                            sx={{ m: 1, width: '3.75rem' }}
                            size="small"
                          >
                            <SelectColor
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={items.value.lengthOperator}
                              name="lengthOperator"
                              onChange={(e) => {
                                handleListChange(
                                  e.target.value,
                                  e.target.name,
                                  items
                                )
                              }}
                              autoWidth
                            >
                              <MenuItem value={'gte'}>≥</MenuItem>

                              <MenuItem value={'lte'}>≤</MenuItem>
                            </SelectColor>
                          </FormControl>

                          <FormControl
                            sx={{
                              m: 1,
                              width: '12.5rem',
                              flexDirection: 'inherit',
                              alignItems: 'center'
                            }}
                            size="small"
                          >
                            <TextFieldColor
                              id="outlined-number"
                              InputLabelProps={{
                                shrink: true
                              }}
                              size="small"
                              sx={{ minWidth: 100, marginLeft: '10px' }}
                              value={items.value.lengthValue}
                              label={t('lengthValue')}
                              name="lengthValue"
                              onChange={(e) => {
                                if (Number.isFinite(Number(e.target.value))) {
                                  const value = Number(e.target.value)
                                    ? Number(e.target.value)
                                    : null

                                  handleListChange(value, e.target.name, items)
                                }
                              }}
                            />

                            <Typography
                              sx={{
                                color: `${color} !important`
                              }}
                            >
                              bp
                            </Typography>
                          </FormControl>
                        </Item>
                      </Stack>
                    ) : (
                      <Stack>
                        <Item></Item>
                      </Stack>
                    )}
                  </Collapse>
                </React.Fragment>
              )
            })}
        </List>

        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            {type === 'save'
              ? t('Preservation filter')
              : type === 'load'
              ? t('Load filter')
              : t('Sharing screening')}

            <Divider />
          </DialogTitle>

          <DialogContent>
            {type === 'save' ? (
              <>
                <FormControl fullWidth sx={{ minWidth: 500 }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={saveVal.filter}
                    onChange={(e) => {
                      setSaveVal({
                        filter: e.target.value
                      })
                    }}
                  >
                    <MenuItem value={'0'}>创建新的过滤器</MenuItem>

                    <MenuItem value={'1'}>创建新的过滤器1</MenuItem>
                  </Select>

                  {saveVal.filter === '0' ? (
                    <TextField
                      id="outlined-number"
                      InputLabelProps={{
                        shrink: true
                      }}
                      size="small"
                      sx={{ marginTop: '20px' }}
                      name="indelValue"
                    />
                  ) : null}
                </FormControl>
              </>
            ) : type === 'load' ? (
              <>
                <FormControl fullWidth sx={{ minWidth: 500 }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={loadVal.filter}
                    onChange={(e) => {
                      setLoadVal({
                        filter: e.target.value
                      })
                    }}
                  >
                    <MenuItem value={'0'}>无</MenuItem>
                  </Select>
                </FormControl>
              </>
            ) : (
              <>
                <FormControl fullWidth sx={{ minWidth: 500, paddingTop: 2 }}>
                  <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={top100Films}
                    getOptionLabel={(option) => option.title}
                    defaultValue={[top100Films[1]]}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        label="收件人"
                      />
                    )}
                    onChange={(e, v: any) => {
                      setShareVal({
                        ...shareVal,
                        emails: v
                      })
                    }}
                  />

                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-selecta"
                    value={shareVal.filter}
                    sx={{ marginTop: '20px' }}
                    onChange={(e) => {
                      setShareVal({
                        ...shareVal,
                        filter: e.target.value
                      })
                    }}
                  >
                    <MenuItem value={'0'}>无</MenuItem>
                  </Select>
                </FormControl>
              </>
            )}

            <Divider />
          </DialogContent>

          <DialogActions sx={{ justifyContent: 'space-between' }}>
            {type === 'load' ? (
              <Box>
                <Button onClick={handleClose} variant="contained" color="error">
                  删除
                </Button>
              </Box>
            ) : (
              <Box></Box>
            )}

            <Box>
              <Button onClick={handleClose} variant="contained">
                {type === 'save'
                  ? t('Preservation filter')
                  : type === 'load'
                  ? t('Load filter')
                  : t('Sharing screening')}
              </Button>

              <Button
                onClick={handleClose}
                variant="contained"
                sx={{ marginLeft: '20px' }}
              >
                {t('cancel')}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>

        <Dialog
          open={machineOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            {t('Machine learning model')}

            <Divider />
          </DialogTitle>

          <DialogContent>
            <Grid
              container
              sx={{ minWidth: 550, overflow: 'auto', maxHeight: 400 }}
            >
              <Grid item xs={10}>
                {machineList.map((items, index) => {
                  return (
                    <Grid container sx={{ marginBottom: '10px' }} key={index}>
                      <Grid item xs={7} sx={{ paddingRight: 10 }}>
                        <TextField
                          id="outlined-number"
                          InputLabelProps={{
                            shrink: true
                          }}
                          size="small"
                          name="machineInput"
                          fullWidth
                          value={items.input}
                          onChange={(e) => {
                            const list = machineList.map((item) => {
                              if (item.key === index)
                                item.input = e.target.value

                              return item
                            })

                            setList(list)
                          }}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={items.select}
                          name={`machineSelect_${index}`}
                          onChange={(e) => {
                            const list = machineList.map((item) => {
                              if (item.key === index)
                                item.select = e.target.value

                              return item
                            })

                            setList(list)
                          }}
                          size="small"
                          fullWidth
                        >
                          {machineSelect.map((item) => {
                            return (
                              <MenuItem value={item} key={item}>
                                {item}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </Grid>

                      <Grid
                        item
                        xs={2}
                        sx={{ display: 'flex', flexDirection: 'row' }}
                      >
                        <IconButton
                          aria-label="add"
                          onClick={() => {
                            setList(
                              [
                                ...machineList,
                                {
                                  input: '',
                                  select: 'symptom',
                                  key: machineList.length
                                }
                              ].map((item, i) => {
                                item.key = i

                                return item
                              })
                            )
                          }}
                        >
                          <PlusCircle />
                        </IconButton>

                        {machineList.length > 1 ? (
                          <IconButton
                            aria-label="min"
                            onClick={() => {
                              setList(
                                machineList
                                  .filter((item) => item.key !== index)
                                  .map((item, i) => {
                                    item.key = i

                                    return item
                                  })
                              )
                            }}
                          >
                            <MinusCircleOutline />
                          </IconButton>
                        ) : null}
                      </Grid>
                    </Grid>
                  )
                })}
              </Grid>

              <Grid item xs={2}>
                <Button
                  variant="contained"
                  startIcon={<Magnify />}
                  size="small"
                  onClick={search}
                >
                  {t('Search')}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    )
  }
)
export default FilterVariants
